import { en } from "./en";

export const hi: typeof en = {
  nav: {
    home: "होम",
    product: "उत्पाद",
    industry: "उद्योग",
    gallery: "गैलरी",
    contribution: "योगदान",
    dealer: "सेल्स पार्टनर्स",
    team: "टीम",
    about: "हमारे बारे में",
    bookNow: "अभी बुक करें",
    resources: "संसाधन",
    news: "समाचार",
    blog: "ब्लॉग",
    evBlog: "ईवी ब्लॉग",
    newsDesc: "प्रेस और घोषणाएं",
    blogDesc: "खेत से कहानियां",
    evBlogDesc: "इलेक्ट्रिक वाहन अंतर्दृष्टि",
  },
  home: {
    metaTitle: "भारत में इलेक्ट्रिक ट्रैक्टर निर्माता | स्वायत्त इलेक्ट्रिक ट्रैक्टर | AutoNXT",
    // heroBadge: "भारत का इलेक्ट्रिक ट्रैक्टर पायनियर",
    heroTitle1: "कल के",
    heroTitleHighlight: "खेतों",
    heroTitle2: "को शक्ति दें।",
    heroDesc: "AutoNXT भारत का अग्रणी इलेक्ट्रिक ट्रैक्टर निर्माता है, जो कृषि और औद्योगिक अनुप्रयोगों के लिए AI-संचालित इलेक्ट्रिक और स्वायत्त ट्रैक्टर बनाता है। शून्य-उत्सर्जन खेती समाधान, उन्नत बैटरी तकनीक का पता लगाएं और आज ही डेमो बुक करें।",
    heroAutomation: {
      titlePart1: "भारत का ",
      titleHighlight: "इलेक्ट्रिक एवं स्वायत्त ट्रैक्टर निर्माता",
      subtitle:
        "ईंधन की लागत को कम करने, रखरखाव को कम करने और शून्य टेलपाइप उत्सर्जन के साथ उच्च टॉर्क देने वाले इलेक्ट्रिक ट्रैक्टरों की खोज करें।",
      featureCards: [
        { title: "स्मार्ट तकनीक", desc: "अधिकतम दक्षता के लिए AI-संचालित सिस्टम।" },
        { title: "उच्च प्रदर्शन", desc: "शक्ति, सटीकता और उत्पादकता के लिए इंजीनियर।" },
        { title: "विश्वसनीय और टिकाऊ", desc: "हर प्रकार की ज़मीन और परिस्थिति के लिए मज़बूत निर्माण।" },
        { title: "सतत भविष्य", desc: "बेहतर कल के लिए पर्यावरण-अनुकूल समाधान।" },
      ],
      taglineBold: "नवाचार करें। संचालित करें। आगे बढ़ें।",
      taglineNormal: "भविष्य बुद्धिमान है। भविष्य स्वायत्त है।",
      bottomFeatures: [
        { title: "AI और स्वचालन", desc: "स्मार्ट संचालन के लिए इंटेलिजेंट नियंत्रण।" },
        { title: "सटीकता और नियंत्रण", desc: "सटीक प्रदर्शन के लिए उन्नत सटीकता तकनीक।" },
        { title: "अधिकतम दक्षता", desc: "उत्पादकता बढ़ाएँ और डाउनटाइम कम करें।" },
        { title: "भविष्य के लिए तैयार", desc: "कल की दुनिया के लिए नवीनतम तकनीक।" },
      ],
    },
    heroDescs: [
      {
        titlePart1: "भारी उद्योगों के लिए",
        titleHighlight: "स्मार्ट समाधान",
        normalText: "हमारे अत्याधुनिक ऑटोमेशन सिस्टम के साथ अपने औद्योगिक कार्यों को बदलें। निर्माण से लेकर विनिर्माण तक, हम स्मार्ट समाधान प्रदान करते हैं।"
      },
      {
        titlePart1: "कल के लिए",
        titleHighlight: "हरित तकनीक",
        normalText: "हमारे पर्यावरण-अनुकूल तकनीकी समाधानों के साथ हरित क्रांति में शामिल हों। एक बेहतर दुनिया के लिए स्वच्छ ऊर्जा, स्मार्ट सिस्टम और टिकाऊ अभ्यास।"
      },
      {
        titlePart1: "आधुनिक कृषि के लिए",
        titleHighlight: "इलेक्ट्रिक ट्रैक्टर",
        normalText: "हमारे उन्नत इलेक्ट्रिक ट्रैक्टरों के साथ शून्य-उत्सर्जन खेती का अनुभव करें। कृषि के भविष्य के लिए टिकाऊ, शक्तिशाली और बुद्धिमान समाधान।"
      }
    ],
    exploreProducts: "उत्पाद देखें",
    bookNow: "अभी बुक करें",
    statsTitle: "भारत के सर्वश्रेष्ठ पर भरोसा",
    videosTitle: "X45H2 को काम करते देखें।",
    videosDesc: "हमारे YouTube चैनल से सीधे वास्तविक वीडियो — बाढ़ वाले धान के खेतों से लेकर औद्योगिक हॉलिंग तक।",
    viewChannel: "चैनल देखें",
    viewGallery: "पूरी गैलरी देखें",
    fieldBannerTag: "खेत में",
    fieldBannerTitle: "सूर्योदय से सूर्यास्त तक।",
    fieldBannerDesc: "एक चार्ज। पूरा दिन। हर मौसम। ऑटोनेक्स्ट भारतीय खेती की लय के लिए बना है।",
    fieldBannerImage: "/sun.webp",
    faqTitle: "अक्सर पूछे जाने वाले प्रश्न",
    ctaTitle: "इलेक्ट्रिक जाने के लिए तैयार?",
    ctaDesc: "शून्य उत्सर्जन के साथ अपने कार्यों को शक्ति दें। खेतों से कारखानों तक, ऑटोनेक्स्ट हर जगह है।",
    ourStory: "हमारी कहानी",
    faqSub: "कोई प्रश्न है? उत्तर खोजें।",
    faqDesc: "हमारे इलेक्ट्रिक ट्रैक्टरों के बारे में अक्सर पूछे जाने वाले प्रश्न।",
    faqCategories: {
      all: "सभी",
      technical: "तकनीकी विनिर्देश",
      charging: "चार्जिंग और बैटरी",
      apps: "अनुप्रयोग और उपयुक्तता",
      cost: "लागत और वित्तपोषण",
      perf: "प्रदर्शन और दक्षता",
    },
    faqs: [
      {
        q: "इलेक्ट्रिक ट्रैक्टर क्या है?",
        a: "एक इलेक्ट्रिक ट्रैक्टर बैटरी से चलने वाला कृषि वाहन है जो पारंपरिक डीजल इंजन के स्थान पर इलेक्ट्रिक मोटर का उपयोग करता है। यह शून्य उत्सर्जन, तत्काल टॉर्क और रिचार्जेबल बैटरी में संग्रहीत स्वच्छ ऊर्जा प्रदान करता है।"
      },
      {
        q: "इलेक्ट्रिक ट्रैक्टर की कीमत कितनी होती है?",
        a: "इलेक्ट्रिक ट्रैक्टर की कीमत मॉडल कॉन्फ़िगरेशन, बैटरी क्षमता और सरकारी सब्सिडी (जैसे FAME-III) पर निर्भर करती है। हालांकि इसकी शुरुआती खरीद कीमत डीजल ट्रैक्टर जैसी ही है, लेकिन इसे चलाने की लागत 80% तक कम है, जिससे जल्दी रिटर्न मिलता है।"
      },
      {
        q: "क्या इलेक्ट्रिक ट्रैक्टर भारी कृषि कार्य संभाल सकते हैं?",
        a: "हाँ। इलेक्ट्रिक मोटरें 0 RPM पर तुरंत अधिकतम टॉर्क प्रदान करती हैं, जिससे उन्हें बेहतर जुताई और ढुलाई की क्षमता मिलती है। हमारा प्रमुख X45H2 मॉडल भारी ढुलाई (10 टन तक) संभालता है और सभी मानक उपकरणों को आसानी से चलाता है।"
      },
      {
        q: "इलेक्ट्रिक ट्रैक्टर की बैटरी कितने समय तक चलती है?",
        a: "ऑटोनेक्स्ट ट्रैक्टर प्रीमियम लिथियम आयरन फॉस्फेट (LFP) बैटरी का उपयोग करते हैं जो 1500+ चार्ज चक्रों के लिए डिज़ाइन की गई हैं, जो 6 से 8 साल के सेवा जीवन में बदल जाती हैं। हमारे बैटरी पैक पर 6 साल की वारंटी मिलती है।"
      },
      {
        q: "क्या इलेक्ट्रिक ट्रैक्टर डीजल से सस्ता है?",
        a: "हाँ, बहुत सस्ता। डीजल ट्रैक्टर चलाने में ₹250-400/घंटे का खर्च आता है, जबकि ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर केवल ₹12-44/घंटे की बिजली की खपत करता है। इससे प्रति वर्ष लगभग ₹1.5 से ₹2.5 लाख की बचत होती है।"
      },
      {
        q: "भारतीय खेतों के लिए कौन सा इलेक्ट्रिक ट्रैक्टर सबसे अच्छा है?",
        a: "यह खेत के आकार पर निर्भर करता है: भारी काम और औद्योगिक उपयोग के लिए H55C2 (55HP) सबसे अच्छा है; मध्यम-से-भारी व्यावसायिक खेती के लिए X45C2 (45HP) आदर्श है; और भारी जुताई तथा औद्योगिक ढुलाई के लिए X45H2 (45HP) बनाया गया है।"
      }
    ],
    techTag: "स्वामित्व वाली तकनीक",
    techHeading: "शुरुआत से निर्मित।",
    techTabs: [
      {
        label: "मोटर",
        title: "32 kW इलेक्ट्रिक मोटर",
        subtitle: "उच्च दक्षता ड्राइव सिस्टम",
        desc: "X45H2 एक उच्च दक्षता वाले 32 kW इलेक्ट्रिक मोटर द्वारा संचालित है जिसे अधिकतम टॉर्क और सटीकता के लिए डिज़ाइन किया गया है। यह सुचारू और शक्तिशाली प्रदर्शन सुनिश्चित करता, जिससे यह भारी-ड्यूटी कृषि कार्यों के लिए आदर्श बन जाता है।",
        specs: [
          { label: "पावर आउटपुट", value: "32 kW" },
          { label: "टॉर्क", value: "अधिकतम टॉर्क" },
          { label: "प्रदर्शन", value: "सटीकता" },
          { label: "अनुप्रयोग", value: "भारी-ड्यूटी" },
        ],
      },
      {
        label: "बैटरी",
        title: "38.4 kWh बैटरी पैक",
        subtitle: "उच्च क्षमता वाली ऊर्जा प्रणाली",
        desc: "38.4 kWh उच्च क्षमता वाली बैटरी से लैस, X45H2 लगातार 10 घंटे / 10 एकड़ का संचालन प्रदान करता है। तेज़ चार्जिंग और विस्तारित जीवनकाल के लिए अनुकूलित, जो खेतों में विश्वसनीयता सुनिश्चित करता है।",
        specs: [
          { label: "क्षमता", value: "38.4 kWh" },
          { label: "रनटाइम", value: "10 घंटे / 10 एकड़" },
          { label: "चार्जिंग", value: "फास्ट चार्ज" },
          { label: "जीवनकाल", value: "विस्तारित" },
        ],
      },
    ],
    softwareTag: "डिजिटल इकोसिस्टम",
    softwareHeading: "इलेक्ट्रिक ट्रैक्टरों के लिए फ्लीट मैनेजमेंट सॉफ्टवेयर",
    softwareDesc: "आपके ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर बेड़े को प्रबंधित, मॉनिटर और बनाए रखने के लिए संपूर्ण डिजिटल उपकरण।",
    softwareTabs: [
      {
        label: "वेब ऐप",
        subtitle: "वेब प्लेटफॉर्म",
        title: "NXT-फ्लीट डैशबोर्ड",
        desc: "एक शक्तिशाली ब्राउज़र-आधारित बेड़ा (फ्लीट) प्रबंधन मंच। वास्तविक समय में हर ट्रैक्टर की निगरानी करें, बैटरी स्वास्थ्य को ट्रैक करें, और एक ही डैशबोर्ड से कई खेतों का प्रबंधन करें।",
        features: ["वास्तविक समय जीपीएस बेड़ा ट्रैकिंग", "बैटरी और निदान निगरानी", "बेड़ा विश्लेषण और प्रदर्शन रिपोर्ट", "मल्टी-फार्म प्रबंधन पोर्टल"],
        cta: "पहुंच का अनुरोध करें",
      },
      {
        label: "मोबाइल ऐप",
        subtitle: "आईओएस और एंड्रॉइड",
        title: "ऑटोनेक्स्ट सर्विस ऐप",
        desc: "सेवा बुक करें, तकनीशियनों को लाइव ट्रैक करें, और अपने ट्रैक्टर का पूरा सेवा इतिहास प्रबंधित करें — सब कुछ अपने फोन से। आईओएस और एंड्रॉइड पर उपलब्ध।",
        features: ["बुक और शेड्यूल सेवा नियुक्तियां", "लाइव तकनीशियन स्थान ट्रैकिंग", "पूर्ण सेवा इतिहास और रिकॉर्ड", "स्पेयर पार्ट्स ऑर्डरिंग और डिलीवरी"],
        cta: "ऐप डाउनलोड करें",
      },
      {
        label: "टैबलेट",
        subtitle: "विश्लेषण डैशबोर्ड",
        title: "NXT-फ्लीट एनालिटिक्स",
        desc: "टैबलेट-अनुकूलित इंटरफ़ेस पर गहन बेड़ा विश्लेषण। खेतों में या कार्यालय में — अपने पूरे बेड़े में प्रदर्शन के रुझान, बैटरी चक्र और परिचालन दक्षता को ट्रैक करें।",
        features: ["बेड़े-व्यापी प्रदर्शन विश्लेषण", "बैटरी स्वास्थ्य और चक्र ट्रैकिंग", "परिचालन दक्षता रिपोर्ट", "बहु-उपयोगकर्ता पहुंच नियंत्रण"],
        cta: "पहुंच का अनुरोध करें",
      },
    ],
    stats: [
      { label: "दिए गए ऑर्डर", value: "270+", sub: "विभिन्न उद्योगों में ट्रैक्टर वितरित किए गए" },
      { label: "संतुष्ट उद्योग", value: "8", sub: "हमारे समाधानों पर भरोसा करने वाले उद्योग" },
      { label: "बचाए गए पेड़", value: "70,650+", sub: "सभी ट्रैक्टरों में वैश्विक CO₂ उत्सर्जन में कमी" },
      { label: "बचाई गई लागत", value: "₹30Cr", sub: "परिचालन लागत में कमी" },
    ],
    trustedBy: "भारत के अग्रणी संगठनों द्वारा विश्वसनीय",
    partners: [
      "बीएआईएफ विकास अनुसंधान",
      "डीकेएसएम",
      "नोएडा अंतर्राष्ट्रीय हवाई अड्डा",
      "जयवंत शुगर्स लिमिटेड",
      "रिलायंस न्यू एनर्जी",
      "थर्मैक्स",
    ],
    lineupTag: "हमारी लाइनअप",
    lineupTitle: "हर खेत और उद्योग के लिए इलेक्ट्रिक ट्रैक्टर",
    viewAllModels: "सभी मॉडल देखें",
    viewDetails: "विवरण देखें",
    products: [
      {
        name: "ऑटोनेक्स्ट X45H2",
        type: "45HP इलेक्ट्रिक ट्रैक्टर",
        tag: "बेस्ट सेलर",
        desc: "सभी कृषि और ढुलाई गतिविधियों में बहुमुखी प्रतिभा और शक्ति। एआई लोड प्रबंधन, सौर-संगत।",
        specs: [
          { label: "मोटर", value: "32 kW" },
          { label: "बैटरी", value: "38.4 kWh" },
          { label: "रेंज", value: "50 किमी" },
        ],
      },
      {
        name: "ऑटोनेक्स्ट X45C2",
        type: "45HP इलेक्ट्रिक ट्रैक्टर",
        tag: "उच्च दक्षता",
        desc: "शून्य उत्सर्जन के साथ 45HP हेवी-ड्यूटी प्रदर्शन — उच्च दक्षता, LFP04 प्रिज़मेटिक बैटरी और 60 किमी रेंज।",
        specs: [
          { label: "मोटर", value: "32 kW" },
          { label: "बैटरी", value: "38.4 kWh" },
          { label: "रेंज", value: "60 किमी" },
        ],
      },
      {
        name: "ऑटोनेक्स्ट H55C2",
        type: "55HP इलेक्ट्रिक ट्रैक्टर",
        tag: "उच्च प्रदर्शन",
        desc: "63.89 kwh लिक्विड-कूल्ड LFP बैटरी, Carraro ट्रांसमिशन और 80 किमी रेंज के साथ उच्च-प्रदर्शन 55HP इलेक्ट्रिक ट्रैक्टर।",
        specs: [
          { label: "मोटर", value: "45 kW" },
          { label: "बैटरी", value: "63.89 kwh" },
          { label: "रेंज", value: "80 किमी" },
        ],
      },
    ],
    precisionTag: "तकनीक",
    precisionTitle: "उन्नत इलेक्ट्रिक ट्रैक्टर तकनीक",
    precisionDesc: "हर पुर्जा भारतीय खेत की परिस्थितियों में अधिकतम दक्षता, सुरक्षा और प्रदर्शन के लिए इंजीनियर किया गया है।",
    featureImage: "/images/precision/image-hi.webp",
    featureImageAlt: "सटीक इंजीनियरिंग",
    industryTag: "औद्योगिक समाधान",
    industryHeading: "कृषि और औद्योगिक अनुप्रयोगों के लिए इलेक्ट्रिक ट्रैक्टर",
    industryDesc: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर भारत के सबसे मांग वाले औद्योगिक वातावरणों में निरंतर कार्यभार के लिए बनाए गए हैं।",
    exploreAllIndustries: "सभी उद्योगों का अन्वेषण करें",
    videoActionTag: "ऑटोनेक्स्ट एक्शन में",
    videoHeading: "X45H2 को काम करते देखें।",
    videoSub: "हमारे YouTube चैनल से सीधे वास्तविक वीडियो — बाढ़ वाले धान के खेतों से लेकर औद्योगिक हॉलिंग तक।",
    videos: [
      "X45H2 उत्पाद विवरण (अंग्रेजी)",
      "बाढ़ वाले खेतों में रोटावेटर की जुताई",
      "पहली डिलीवरी — जयवंत शुगर मिल",
      "45HP इलेक्ट्रिक ट्रैक्टर फुल पावर डेमो",
      "ढुलाई, टिलर, रीपर और वाटर वॉश",
      "X45H2 उत्पाद विवरण — हिंदी में",
    ],
    readyToElectric: "इलेक्ट्रिक जाने के लिए तैयार?",
    readyToElectricDesc: "5,000+ भारतीय किसानों में शामिल हों जो ऑटोनेक्स्ट में आ गए हैं। आज ही अपना ट्रैक्टर बुक करें।",
    liveTag: "लाइव",
    visitingPass: {
      connectTag: "विजिट और कनेक्ट",
      titlePre: "एक ",
      titleHighlight: "विजिटिंग पास",
      titlePost: " या ऐप प्राप्त करें",
      showroom: "फैक्ट्री और शोरूम",
      bookPass: "विजिटिंग पास बुक करें",
      visitorPass: "विजिटर पास",
      hinjewadi: "हिंजेवाड़ी फेज 2, पुणे",
      namePlaceholder: "आपका पूरा नाम",
      generatePass: "विजिटिंग पास जेनरेट करें",
      nameLabel: "नाम",
      dateLabel: "तारीख",
      purposeLabel: "उद्देश्य",
      blankVal: "— — —"
    },
    mobileApp: {
      tag: "मोबाइल एप्लीकेशन",
      titlePre: "ऑटोनेक्स्ट ",
      titleHighlight: "आपके फोन पर",
      desc: "सेवा बुक करें, अपने ट्रैक्टर को ट्रैक करें, बेड़े के संचालन का प्रबंधन करें और अलर्ट के साथ अपडेट रहें — सब कुछ अपनी जेब से।",
      alert: "वास्तविक समय अलर्ट और सूचनाएं",
      gps: "लाइव ट्रैक्टर जीपीएस ट्रैकिंग",
      history: "सेवा बुकिंग और इतिहास",
      appStore: "ऐप स्टोर",
      googlePlay: "गूगल प्ले",
      downloadOn: "डाउनलोड करें",
      getItOn: "प्राप्त करें",
    },
    whyAutoNXT: {
      title: "किसान इलेक्ट्रिक ट्रैक्टर क्यों अपना रहे हैं?",
      bullets: [
        { title: "कम परिचालन लागत", desc: "डीजल से बिजली पर स्विच करके ईंधन खर्च में 80% तक की बचत करें।" },
        { title: "कम रखरखाव", desc: "70% कम गतिशील पुर्जों का मतलब है नो इंजन ऑयल या फिल्टर बदलाव।" },
        { title: "शून्य डीजल निर्भरता", desc: "डीजल की बढ़ती और अस्थिर कीमतों से अपनी खेती को सुरक्षित रखें।" },
        { title: "शांत संचालन", desc: "कम शोर और कंपन ऑपरेटर की थकान को कम करते हैं।" },
        { title: "उच्च तत्काल टॉर्क", desc: "0 RPM से उपलब्ध अधिकतम टॉर्क भारी जुताई और ढुलाई में बेहतर शक्ति देता है।" }
      ]
    }
  },
  gallery: {
    metaTitle: "AutoNxt इलेक्ट्रिक ट्रैक्टर गैलरी | फोटो और वीडियो",
    metaDescription: "कृषि, खेतों और औद्योगिक कार्यों में काम करते AutoNxt इलेक्ट्रिक ट्रैक्टरों के चित्र और वीडियो देखें।",
    sectionHeading: "गैलरी श्रेणियां ब्राउज़ करें",
    title: "ऑटोनेक्स्ट को",
    titleHighlight: "काम करते देखें।",
    desc: "खेतों, उद्योगों और आयोजनों में ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टरों की पूरी फोटो गैलरी देखें।",
    photos: "फोटो",
    events: "आयोजन",
    videos: "वीडियो",
    clickToView: "पूर्ण आकार देखने के लिए किसी भी फोटो पर क्लिक करें",
    eventBannerTitle: "आधिकारिक सरकारी हस्तांतरण समारोह",
    eventBannerDesc: "29 जून 2025 — ऑटोनेक्स्ट ने सरकारी अधिकारियों और मीडिया की उपस्थिति में X45H2 ट्रैक्टर सौंपा।",
    watchOnYouTube: "YouTube पर देखें",
    moreOnYouTube: "YouTube पर और देखें",
    viewAllVideos: "YouTube पर सभी वीडियो देखें",
    scheduleDemo: "डेमो शेड्यूल करें",
    seeInPerson: "इसे व्यक्तिगत रूप से देखना चाहते हैं?",
    seeInPersonDesc: "अपने खेत पर या हमारे निकटतम अनुभव केंद्र पर लाइव डेमो शेड्यूल करें।",
    galleryBadge: "ऑटोनेक्स्ट गैलरी",
    youtubeTag: "YouTube",
    youtubeDesc: "उत्पाद वीडियो, फार्म डेमो, उद्योग अनुप्रयोगों और कंपनी अपडेट के लिए ऑटोनेक्स्ट YouTube चैनल को सब्सक्राइब करें।",
  },
  about: {
    metaTitle: "AutoNxt के बारे में | इलेक्ट्रिक ट्रैक्टर एवं ऑटोमेशन के अग्रदूत",
    metaDescription: "AutoNxt के बारे में जानें, जो भारत का अग्रणी इलेक्ट्रिक ट्रैक्टर निर्माता है। हमारे मिशन, संस्थापकों और तकनीक के बारे में जानें।",
    tag: "ऑटोनेक्स्ट के बारे में",
    heroTitle: "हम मानते हैं कि प्रौद्योगिकी",
    heroHighlight: "क्रांति",
    heroTitle2: "ला सकती है जिस तरह से हम खेती करते हैं।",
    heroDesc: "हमने इंजीनियरों की एक छोटी टीम के रूप में शुरुआत की जो समाज पर बड़े, स्थायी प्रभाव वाले विचारों पर काम करने के जुनून से भरे थे।",
    missionTag: "हमारा मिशन",
    missionTitle: "किसानों को सशक्त बनाना। हमारे ग्रह की रक्षा करना।",
    missionDesc: "टिकाऊ, कुशल और शक्तिशाली इलेक्ट्रिक ट्रैक्टर प्रदान करके खेती में क्रांति लाना।",
    processTag: "हमारी इंजीनियरिंग प्रक्रिया",
    processTitle: "उच्चतम मानकों के अनुसार निर्मित।",
    journeyTag: "हमारी यात्रा",
    journeyTitle: "अवधारणा से बाजार नेता तक।",
    teamTag: "हमारी टीम",
    teamTitle: "हमारी टीम से मिलें",
    teamDesc: "हमारी विविध विशेषज्ञों की टीम कृषि उद्योग में क्रांति लाने के लिए समर्पित है।",
    advisorsTag: "हमारे सलाहकार",
    advisorsTitle: "उद्योग के दिग्गज हमारे विज़न का मार्गदर्शन कर रहे हैं।",
    ctaTitle: "हमारी यात्रा का हिस्सा बनना चाहते हैं?",
    ctaDesc: "भारत में टिकाऊ खेती का भविष्य बनाने में हमारे साथ जुड़ें।",
    bookDemo: "डेमो बुक करें",
    ourImpact: "हमारा प्रभाव",
    connect: "जुड़ें",
  },
  chat: {
    welcome: "👋 ऑटोनेक्स्ट एआई में आपका स्वागत है\n\nमैं आपको इलेक्ट्रिक ट्रैक्टर और स्मार्ट खेती के बारे में जानने में मदद करता हूँ।\n\nआप **हिंदी**, **English**, **मराठी**, या **తెలుగు** में पूछ सकते हैं — जिस भाषा में पूछेंगे, उसी में जवाब मिलेगा।\n\nनीचे **Talk with agent** (फोन) या **Schedule meeting** (Zoom) चुनें — या लिखें: \"एजेंट से बात करो\", \"मीटिंग शेड्यूल करो\"।",
    callPromptNow: "ऑटोनेक्स्ट टीम को अभी कॉल करें",
    callPromptScheduled: "कॉल शेड्यूल करें",
    meetingOpenMessage: "Zoom पर सेल्स टीम से मिलने के लिए फॉर्म भरें।",
    bookingOpenMessage: "मैं ट्रैक्टर बुकिंग में आपकी मदद कर सकता हूं।",
    callSupport: "टेलीफोन सहायता और बिक्री",
    callDescription: "अपना नंबर दर्ज करें। हमारे एजेंट व्यावसायिक घंटों के दौरान या आपके पसंदीदा समय पर तुरंत कॉल करेंगे।",
    callTypeSupport: "तकनीकी सहायता",
    callTypeSales: "बिक्री और डीलरशिप",
    meetingHeading: "ज़ूम मीटिंग शेड्यूल करें",
    meetingLanguageLabel: "पसंदीदा भाषा:",
    salesMeetingInfo: "मीटिंग उत्पाद विशेषज्ञ के साथ गूगल मीट के माध्यम से आयोजित की जाती हैं (सुबह 10 बजे - शाम 5 बजे)।",
    scheduleMeeting: "मीटिंग शेड्यूल की पुष्टि करें",
    bookingHeader: "ऑटोनेक्स्ट ट्रैक्टर प्री-बुक करें",
    inputPlaceholder: "कुछ भी पूछें...",
    clearSession: "सेशन साफ करें",
    talkWithAgent: "एजेंट से बात करें",
    assistantSubtitle: "स्मार्ट खेती सहायक",
  },

  common: {
    readMore: "और पढ़ें",
    learnMore: "अधिक जानें",
    getInTouch: "संपर्क करें",
    subscribe: "अपडेट के लिए सब्सक्राइब करें",
    copyright: "© 2025 ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. सर्वाधिकार सुरक्षित।",
    madeIn: "भारत में निर्मित 🇮🇳 भारतीय कृषि और उद्योग के लिए",
    careers: "करियर",
    privacyPolicy: "गोपनीयता नीति",
    termsConditions: "नियम और शर्तें",
    accountDeletion: "खाता हटाना",
    fleetSolutions: "फ्लीट सॉल्यूशंस",
    batterySystems: "बैटरी सिस्टम",
    motors: "NXT-ड्राइव मोटर्स",
    slogan: "उद्योग, अवसंरचना और कृषि के लिए अगली पीढ़ी की इलेक्ट्रिक मशीनें बना रहे हैं।",
    cancel: "रद्द करें",
    loadingModel: "3D मॉडल लोड हो रहा है...",
    dragToRotate: "↺ घुमाने के लिए ड्रैग करें",
    exploreAll: "सभी देखें",
    collapseList: "सूची बंद करें",
  },
  book: {
    title: "डेमो बुक करें",
    desc: "ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रैक्टर को प्रत्यक्ष अनुभव करें। अपना विवरण भरें और हमारी टीम संपर्क करेगी।",
  },
  news: {
    metaTitle: "AutoNxt समाचार और प्रेस विज्ञप्ति | इलेक्ट्रिक ट्रैक्टर अपडेट",
    metaDescription: "ऑटोनेक्स्ट ऑटोमेशन की नवीनतम खबरें, घोषणाएं और मीडिया कवरेज से अपडेट रहें।",
    tag: "समाचार और प्रेस",
    title: "ऑटोनेक्स्ट",
    titleHighlight: "सुर्खियों में।",
    desc: "ऑटोनेक्स्ट ऑटोमेशन की नवीनतम खबरें, घोषणाएं और मीडिया कवरेज से अपडेट रहें।",
    featured: "विशेष कहानी",
    allNews: "सभी समाचार",
    ctaTitle: "मीडिया पूछताछ",
    ctaDesc: "प्रेस किट, साक्षात्कार और साझेदारी घोषणाओं के लिए ऑटोनेक्स्ट टीम से संपर्क करें।",
    contactPress: "प्रेस टीम से संपर्क करें",
    searchPlaceholder: "समाचार खोजें...",
    allCategories: "सभी श्रेणियां",
    readArticle: "लेख पढ़ें",
    noArticlesFound: "कोई लेख नहीं मिला",
    noArticlesDesc: "अपनी खोज बदलें या दूसरी श्रेणी चुनें।",
    authorLabel: "लेखक",
    pressInquiries: "प्रेस और मीडिया पूछताछ",
    pressDesc: "प्रेस विज्ञप्ति, उच्च-रिज़ॉल्यूशन छवियों और मीडिया साक्षात्कारों के लिए, कृपया हमारी पीआर टीम से संपर्क करें।",
    contactPr: "पीआर टीम से संपर्क करें",
    liveCovers: "लाइव कवरेज",
    pressMedia: "प्रेस और मीडिया",
    latestUpdates: "नवीनतम अपडेट",
  },
  blog: {
    metaTitle: "फील्ड स्टोरीज़ और फार्मिंग ब्लॉग | AutoNxt इलेक्ट्रिक ट्रैक्टर",
    metaDescription: "इलेक्ट्रिक ट्रैक्टरों, टिकाऊ कृषि और भारत में खेती के भविष्य पर ऑटोनेक्स्ट टीम की कहानियां।",
    tag: "ऑटोनेक्स्ट ब्लॉग",
    title: "खेती के भविष्य पर",
    titleHighlight: "अंतर्दृष्टि।",
    desc: "इलेक्ट्रिक ट्रैक्टर, टिकाऊ कृषि और भारत में खेती के भविष्य पर ऑटोनेक्स्ट टीम की कहानियां।",
    featured: "विशेष पोस्ट",
    allPosts: "सभी पोस्ट",
    readFull: "पूरी पोस्ट पढ़ें",
    writeFor: "ऑटोनेक्स्ट के लिए लिखना चाहते हैं?",
    writeDesc: "हम किसानों, इंजीनियरों और कृषि-तकनीक विशेषज्ञों के साथ मिलकर वास्तविक कहानियां साझा करते हैं।",
    searchPlaceholder: "लेख खोजें...",
    allCategories: "सभी श्रेणियां",
    readArticle: "लेख पढ़ें",
    noArticlesFound: "कोई लेख नहीं मिला",
    noArticlesDesc: "अपनी खोज बदलें या दूसरी श्रेणी चुनें।",
    editorsPick: "संपादक की पसंद",
    newBadge: "नया",
    readAction: "पढ़ें",
    authorLabel: "लेखक",
  },
  evBlog: {
    metaTitle: "इलेक्ट्रिक वाहन जानकारी और तकनीक ब्लॉग | AutoNxt",
    metaDescription: "भारतीय और वैश्विक कृषि में इलेक्ट्रिक वाहनों पर गहन तकनीकी जानकारी, बाजार विश्लेषण और नीति समीक्षा।",
    tag: "ईवी ज्ञान केंद्र",
    title: "सब कुछ इलेक्ट्रिक।",
    titleHighlight: "सब कुछ कृषि।",
    desc: "भारतीय और वैश्विक कृषि में इलेक्ट्रिक वाहनों पर गहन तकनीकी जानकारी, बाजार विश्लेषण और नीति समीक्षा।",
    ctaTitle: "ईवी समाचार से जुड़े रहें",
    ctaDesc: "इलेक्ट्रिक कृषि, बैटरी तकनीक और नीति अपडेट पर नवीनतम जानकारी अपने इनबॉक्स में पाएं।",
    searchPlaceholder: "लेख खोजें...",
    allCategories: "सभी श्रेणियां",
    readArticle: "लेख पढ़ें",
    noArticlesFound: "कोई लेख नहीं मिला",
    noArticlesDesc: "अपनी खोज बदलें या दूसरी श्रेणी चुनें।",
    evRevolution: "ईवी क्रांति",
  },
  productPage: {
    metaTitle: "AutoNxt इलेक्ट्रिक ट्रैक्टर लाइनअप | उच्च प्रदर्शन वाले ई-ट्रैक्टर",
    metaDescription: "कृषि और भारी औद्योगिक कार्यों के लिए डिज़ाइन किए गए AutoNxt के इलेक्ट्रिक ट्रैक्टरों की खोज करें।",
    badge: "इलेक्ट्रिक लाइनअप 2025",
    title: "इलेक्ट्रिक",
    titleHighlight: "ट्रैक्टर।",
    desc: "टिकाऊ, शक्तिशाली और कुशल इलेक्ट्रिक ट्रैक्टरों के साथ कृषि में क्रांति लाना — हर खेत, हर इलाके के लिए निर्मित।",
    hpRange: "HP रेंज",
    charge: "चार्ज",
    availableNow: "अभी उपलब्ध है",
    implementLabel: "उपकरण",
    filterTabs: {
      all: "सभी उत्पाद",
      tractors: "ट्रैक्टर",
      attachments: "कृषि उपकरण"
    },
    chargingTime: "3–6 घंटे",
    modelsCount: "3 ट्रैक्टर",
    viewDetails: "विवरण देखें",
    book: "बुक",
    viewGallery: "गैलरी देखें",
    scheduleTestDrive: "डेमो शेड्यूल करें",
    seeIndustries: "उद्योग देखें",
    models: "मॉडल",
    flagshipModel: "फ्लैगशिप मॉडल",
    zeroEmissions: "शून्य उत्सर्जन",
    electric100: "100% इलेक्ट्रिक",
    ourProducts: "हमारे उत्पाद",
    exploreAll: "पूरी श्रृंखला देखें",
    exploreDesc: "छोटे खेतों के कॉम्पैक्ट मॉडल से लेकर भारी व्यावसायिक ट्रैक्टरों तक — हर काम के लिए उपयुक्त उपकरण।",
    implementsTitle: "कृषि उपकरण और अटैचमेंट",
    coreTech: "मूल तकनीक",
    builtDifferent: "कुछ अलग बात है।",
    fieldBannerTag: "जून 2025 · हस्तांतरण समारोह",
    fieldBannerTitle: "खेत में ट्रैक्टर।",
    readyToPower: "खेतों को शक्ति देने के लिए तैयार?",
    experienceTag: "ऑटोनेक्स्ट का अनुभव करें",
    features: {
      zeroEmissions: "शून्य उत्सर्जन",
      zeroEmissionsDesc: "100% इलेक्ट्रिक ड्राइवट्रेन",
      instantTorque: "तत्काल टॉर्क",
      instantTorqueDesc: "हर इलाके पर शून्य आरपीएम से",
      fastCharging: "फास्ट चार्जिंग",
      fastChargingDesc: "3-4 घंटे में पूरी तरह से चार्ज",
      warranty: "5-साल की वारंटी",
      warrantyDesc: "अखिल भारतीय सेवा नेटवर्क का समर्थन"
    },
    specs: {
      power: "शक्ति",
      battery: "बैटरी",
      range: "रेंज",
      runtime: "रन टाइम",
      charging: "चार्जिंग",
      lifting: "उठाने की क्षमता",
      torque: "अधिकतम टॉर्क",
    },
    tractorsList: {
      x45h2: {
        badge: "फ्लैगशिप",
        type: "45HP इलेक्ट्रिक ट्रैक्टर",
        desc: "उन्नत बैटरी तकनीक और बड़े पैमाने पर कृषि कार्यों के लिए बेहतर प्रदर्शन के साथ हमारा प्रमुख 45HP इलेक्ट्रिक ट्रैक्टर।",
        specs: {
          power: "32 kW",
          battery: "38.4 kWh",
          range: "50 किमी",
          charging: "ऑफ-बोर्ड - DC फास्ट चार्जिंग 60kW - 45 मिनट"
        }
      },
      h55c2: {
        badge: "उच्च प्रदर्शन",
        type: "55HP इलेक्ट्रिक ट्रैक्टर",
        desc: "45 kW PMSM मोटर, 63.89 kwh LFP लिक्विड-कूल्ड बैटरी, कैरारो ट्रांसमिशन, 410 NM टॉर्क और 80 किमी रेंज के साथ कठिन कृषि और औद्योगिक कार्यों के लिए उच्च प्रदर्शन वाला 55HP इलेक्ट्रिक ट्रैक्टर।",
        specs: {
          power: "45 kW",
          battery: "63.89 kwh LFP",
          range: "80 किमी",
          charging: "AC फास्ट 13.2 kW / DC फास्ट 40kW ड्यूल गन"
        }
      },
      x45c2: {
        badge: "उच्च दक्षता",
        type: "45HP प्रीमियम ट्रैक्टर",
        desc: "वाटर-कूल्ड PMSM मोटर, स्मार्ट टेलीमैटिक्स और फास्ट चार्जिंग के साथ व्यावसायिक खेती के लिए उच्च दक्षता वाला 45HP इलेक्ट्रिक ट्रैक्टर।",
        specs: {
          power: "32 kW",
          battery: "38.4 kWh LFP",
          range: "60 किमी",
          charging: "AC स्लो 6.6 kW / AC फास्ट 13.2 kW"
        }
      }
    },
    implementsList: {
      bucket: {
        badge: "भारी कार्य",
        name: "18 फीट ग्रैबर बकेट",
        desc: "कुशल सामग्री प्रबंधन और उत्खनन कार्यों के लिए हैवी-ड्यूटी 18 फीट ग्रैबर बकेट।"
      },
      catcher: {
        badge: "सटीकता",
        name: "18 फीट कैचर",
        desc: "कुशल सामग्री संग्रह और कटाई के लिए सटीक-इंजीनियर 18 फीट कैचर।"
      },
      loader: {
        badge: "अधिकतम भार",
        name: "18 फीट लोडर बकेट",
        desc: "लोडिंग और सामग्री परिवहन में अधिकतम दक्षता के लिए हैवी-ड्यूटी 18 फीट लोडर बकेट।"
      }
    },
    techSpecsList: {
      battery: {
        title: "LFP बैटरी पैक",
        desc: "बेहतर थर्मल प्रबंधन और उन्नत लिक्विड कूलिंग सिस्टम के साथ कस्टम बैटरी पैक तकनीक। उच्च-घनत्व वाले लिथियम आयरन फॉस्फेट (LFP) सेल। 2,000+ चार्ज चक्र, IP67 वॉटरप्रूफ।",
        stat: "2,000+",
        statLabel: "चार्ज चक्र"
      },
      motor: {
        title: "NXT-ड्राइव मोटर",
        desc: "इंटेलिजेंट कंट्रोल सिस्टम द्वारा संचालित हाई-टॉर्क इलेक्ट्रिक पावरट्रेन (32 kW / 45 kW मोटर विकल्प)। 96% चरम दक्षता, त्वरित टॉर्क के साथ अक्षीय प्रवाह स्थायी चुंबक मोटर, भारत में निर्मित।",
        stat: "96%",
        statLabel: "चरम दक्षता"
      }
    }
  },
  bookPage: {
    metaTitle: "डेमो बुक करें और AutoNxt से संपर्क करें | इलेक्ट्रिक ट्रैक्टर",
    metaDescription: "AutoNxt इलेक्ट्रिक ट्रैक्टर की टेस्ट ड्राइव बुक करें या प्री-बुक करें। आज ही स्मार्ट कृषि में बदलाव लाएं।",
    tag: "ऑटोनेक्स्ट से संपर्क करें",
    title: "आइए बनाएं ",
    titleHighlight: "भविष्य।",
    desc: "हमारे इलेक्ट्रिक ट्रैक्टरों के बारे में प्रश्न हैं या डेमो शेड्यूल करना चाहते हैं? ऑटोनेक्स्ट टीम से जुड़ें और टिकाऊ गतिशीलता के भविष्य की खोज करें।",
    stats: {
      support: "सहायता",
      supportVal: "24/7",
      locations: "स्थान",
      locationsVal: "अखिल भारतीय",
      response: "प्रतिक्रिया",
      responseVal: "< 24 घंटे"
    },
    form: {
      send: "संदेश भेजें",
      desc: "नीचे दिया गया फॉर्म भरें और हमारी टीम जल्द ही आपसे संपर्क करेगी।",
      name: "पूरा नाम",
      email: "ईमेल पता",
      phone: "फ़ोन नंबर",
      location: "पसंदीदा स्थान",
      model: "ट्रैक्टर मॉडल",
      date: "पसंदीदा तिथि",
      subject: "विषय",
      message: "आपका संदेश",
      submitting: "सबमिट किया जा रहा है...",
      submitBtn: "बुकिंग सबमिट करें",
      success: "बुकिंग सफलतापूर्वक सबमिट हो गई! हम जल्द ही आपसे संपर्क करेंगे।",
      help: "अपनी कृषि आवश्यकताओं / प्रश्नों का वर्णन करें...",
      submitCall: "मुझे अभी कॉल करें",
      scheduleCall: "कॉल अनुरोध शेड्यूल करें",
      city: "शहर / जिला",
      topic: "मीटिंग का विषय / प्रश्न"
    },

    contactInfo: {
      title: "संपर्क करें",
      call: "हमें कॉल करें",
      email: "हमें ईमेल करें",
      visit: "हमारे पास आएं",
      visitVal: "704 और 705 एम्फोटेक आईटी पार्क, ठाणे, महाराष्ट्र",
      hours: "काम के घंटे",
      hoursVal: "सोमवार - शनिवार, सुबह 9 से शाम 6 बजे"
    },
    cta: {
      tag: "टेस्ट ड्राइव",
      title: "नवाचार का अनुभव करें",
      desc: "अपने नजदीकी स्थान पर इलेक्ट्रिक ट्रैक्टर के लाइव डेमो का समय निर्धारित करें।",
      btn: "टेस्ट ड्राइव बुक करें"
    }
  },
  tractorDetailPage: {
    texts: {
      allTractors: "सभी ट्रैक्टर",
      comingSoon: "जल्द आ रहा है",
      availableNow: "अभी उपलब्ध है",
      reserveNow: "अभी बुक करें",
      registerInterest: "रुचि दर्ज करें",
      bookTestDrive: "टेस्ट ड्राइव बुक करें",
      technicalSpecs: "तकनीकी विवरण",
      fullSpecs: "पूर्ण विवरण — ",
      keyFeatures: "मुख्य विशेषताएं",
      whatSetsApart: "जो इसे अलग बनाता है",
      coreTech: "मूल तकनीक",
      applications: "अनुप्रयोग",
      whereWorksBest: "जहाँ यह सबसे अच्छा काम करता है",
      costComparison5Year: "5-साल की लागत तुलना",
      dieselTractor45HP: "डीजल ट्रैक्टर (45HP)",
      dieselFuelMaint: "₹8–12 लाख/वर्ष ईंधन · ₹1.5 लाख/वर्ष सेवा",
      electricFuelMaint: "₹1.2–2 लाख/वर्ष बिजली · ₹40 हजार/वर्ष सेवा",
      dieselSavingsNote: "डीजल की तुलना में 5 वर्षों में ₹35–50 लाख बचाएं",
      basedOnUsageNote: "प्रतिदिन 8 घंटे, प्रति वर्ष 300 दिनों के संचालन के आधार पर",
      getTractor: "ट्रैक्टर प्राप्त करें",
      registerTractor: "ट्रैक्टर के लिए पंजीकरण करें",
      ctaDescAvailable: "अपनी इकाई आरक्षित करें, टेस्ट ड्राइव बुक करें, या कस्टम कोट के लिए हमारी टीम से बात करें।",
      ctaDescUpcoming: "अपनी रुचि दर्ज करें और उत्पाद लॉन्च होने पर प्राथमिकता वितरण अधिसूचना प्राप्त करें।",
      compareAllModels: "सभी मॉडलों की तुलना करें",
    },
    tractors: {
      x45h2: {
        name: "AutoNxt X45H2",
        type: "45HP इलेक्ट्रिक ट्रैक्टर",
        badge: "फ्लैगशिप",
        badgeColor: "bg-primary",
        tagline: "भारत का सबसे शक्तिशाली इलेक्ट्रिक ट्रैक्टर",
        desc: "X45H2 ऑटोनेक्स्ट का प्रमुख कृषि और औद्योगिक इलेक्ट्रिक ट्रैक्टर है। बड़े खेतों, चीनी मिलों, सीमेंट संयंत्रों और निर्माण स्थलों पर भारी-भरकम संचालन के लिए निर्मित — यह 45HP का तत्काल इलेक्ट्रिक टॉर्क, 10 घंटे / 10 एकड़ का रनटाइम और शून्य प्रत्यक्ष उत्सर्जन प्रदान करता है। भारत का iCAT-प्रमाणित इलेक्ट्रिक ट्रैक्टर, अब पूरे भारत में व्यावसायिक रूप से उपलब्ध है।",
        image: "/3dmodel/x45h2.glb",
        glbSrc: "/3dmodel/x45h2.glb",
        status: "available",
        specs: [
          { label: "पावर (शक्ति)", value: "32 kW (45HP के बराबर)" },
          { label: "बैटरी क्षमता", value: "38.4 kWh (सामान्य LFP)" },
          { label: "चार्जर्स", value: "AC 6.6 kW / AC फ़ास्ट 13.4 kW" },
          { label: "चार्जिंग समय", value: "DC फ़ास्ट: 60kW - 45 मिनट" },
          { label: "अधिकतम टॉर्क", value: "214 NM" },
          { label: "वजन", value: "2.4 टन" },
          { label: "उठाने की क्षमता", value: "1800 kg" },
          { label: "गति सीमा", value: "1.9 - 35 किमी / घंटा" },
          { label: "पीटीओ पावर", value: "24.5 kW / 33 HP" },
          { label: "इंजन कूलिंग", value: "वाटर कूल्ड मोटर" },
          { label: "टेलीमैटिक्स", value: "सक्षम" },
          { label: "बैटरी वारंटी", value: "6 वर्ष / 6000 घंटे" },
        ],
        features: [
          {
            title: "रिमोट फ्लीट टेलीमैटिक्स",
            desc: "ऑटोनेक्स्ट क्लाउड प्लेटफॉर्म के माध्यम से रीयल-टाइम जीपीएस ट्रैकिंग, बैटरी स्थिति, motor स्वास्थ्य और जियो-फेंसिंग — किसी भी डिवाइस से सुलभ।"
          },
          {
            title: "एआई-असिस्टेड लोड प्रबंधन",
            desc: "बुद्धिमान बिजली वितरण प्रणाली लोड और इलाके के आधार पर स्वचालित रूप से टॉर्क आउटपुट और रीजेन ब्रेकिंग को अनुकूलित करती है।"
          },
        ],
        battery: [
          { label: "रसायन शास्त्र", value: "लिथियम आयरन फॉस्फेट (LFP)" },
          { label: "क्षमता", value: "38.4 kWh" },
          { label: "सेल साइकिल लाइफ", value: "2,000+" },
          { label: "आईपी रेटिंग", value: "IP67" },
          { label: "कूलिंग", value: "सक्रिय लिक्विड कूलिंग" },
        ],
        motor: [
          { label: "प्रकार", value: "स्थायी चुंबक सिंक्रोनस मोटर" },
          { label: "चरम शक्ति", value: "32 kW (45 HP)" },
          { label: "चरम टॉर्क", value: "280 Nm" },
          { label: "चरम दक्षता", value: "96%" },
        ],
        applications: [
          "बड़े पैमाने पर धान और गेहूं की खेती",
          "गन्ना ढुलाई और पेराई कार्य",
          "बायोमास बेलिंग और परिवहन",
          "सीमेंट संयंत्र सामग्री प्रबंधन",
          "निर्माण स्थल मिट्टी की तैयारी",
          "हवाई अड्डा जमीनी सहायता संचालन",
          "धातु संयंत्र आंतरिक रसद",
        ],
        highlights: [
          "भारत का iCAT-प्रमाणित इलेक्ट्रिक ट्रैक्टर",
          "पहली व्यावसायिक डिलीवरी: जयवंत शुगर्स लिमिटेड, कराड (मार्च २०२४)",
          "अभी उपलब्ध है — उत्पादन इकाइयाँ वितरित करने के लिए तैयार",
          "FAME-III और राज्य ईवी सब्सिडी के लिए पात्र",
          "6 साल की व्यापक वारंटी",
          "मेड इन इंडिया — ठाणे, महाराष्ट्र",
        ],
      },
      h55c2: {
        name: "AutoNxt H55C2",
        type: "55HP इलेक्ट्रिक ट्रैक्टर",
        badge: "उच्च प्रदर्शन",
        badgeColor: "bg-accent",
        tagline: "मांगलिक कृषि और औद्योगिक संचालन के लिए उच्च-प्रदर्शन इलेक्ट्रिक पावर",
        desc: "H55C2 बड़े पैमाने की कृषि और औद्योगिक कार्यों के लिए ऑटोनेक्स्ट का सबसे शक्तिशाली शून्य-उत्सर्जन इलेक्ट्रिक ड्राइवट्रेन लाता है। 45 kW PMSM मोटर और 63.89 kwh LFP लिक्विड-कूल्ड बैटरी के साथ, यह 410 NM का टॉर्क और रेटेड लोड के साथ 80 किमी की रेंज प्रदान करता है।",
        image: "/3dmodel/h55c2.glb",
        glbSrc: "/3dmodel/h55c2.glb",
        status: "available",
        specs: [
          { label: "मोटर पावर", value: "45 kW (55 HP के बराबर)" },
          { label: "बैटरी क्षमता", value: "63.89 kwh (LFP लिक्विड कूल्ड)" },
          { label: "चार्जर (AC)", value: "AC फास्ट - 13.2 kW (ऑफ-बोर्ड, वैकल्पिक) III फेज" },
          { label: "DC फास्ट चार्जर", value: "DC फास्ट - 40kW (ऑफ-बोर्ड, वैकल्पिक) DUAL Gun" },
          { label: "गेयर", value: "8F + 2R" },
          { label: "अधिकतम टॉर्क", value: "410 NM" },
          { label: "वजन", value: "~2.8 टन" },
          { label: "उठाने की क्षमता", value: "2800 kg" },
          { label: "गति सीमा", value: "1.9 – 35 किमी/घंटा" },
          { label: "पीटीओ पावर", value: "24.5 kW / 32.8 HP" },
          { label: "ट्रांसमिशन", value: "Constant Mesh (Carraro)" },
          { label: "टेलीमैटिक्स", value: "सक्षम" },
          { label: "बैटरी वारंटी", value: "5 वर्ष / 1500 चार्जिंग साइकिल" },
          { label: "रेंज", value: "रेटेड लोड के साथ 80 किमी" },
        ],
        features: [
          {
            title: "लिक्विड-कूल्ड LFP बैटरी पैक",
            desc: "उन्नत 63.89 kwh LFP बैटरी लिक्विड कूलिंग के साथ भारी लोड और चरम तापमान में भी स्थिर बिजली आपूर्ति सुनिश्चित करती है।"
          },
          {
            title: "Carraro कॉन्स्टेंट मेश ट्रांसमिशन",
            desc: "8F + 2R गियर और साइड शिफ्ट के साथ हैवी-ड्यूटी Carraro ट्रांसमिशन औद्योगिक-ग्रेड संचालन के लिए सटीक नियंत्रण और अधिकतम स्थायित्व प्रदान करता है।"
          },
          {
            title: "डुअल चार्जिंग विकल्प",
            desc: "AC फास्ट (13.2 kW) और DC फास्ट (40 kW) चार्जिंग को DUAL Gun क्षमता के साथ सपोर्ट करता है, जो निरंतर संचालन के लिए लचीला और त्वरित रिचार्जिंग सक्षम करता है।"
          },
        ],
        battery: [
          { label: "रसायन शास्त्र", value: "लिथियम आयरन फॉस्फेट (LFP)" },
          { label: "क्षमता", value: "63.89 kwh (लिक्विड कूल्ड)" },
          { label: "सेल साइकिल लाइफ", value: "1,500+ चार्जिंग-डिस्चार्ज साइकल" },
          { label: "वारंटी", value: "5 वर्ष / 1500 चार्जिंग साइकल (जो भी पहले हो)" },
          { label: "आईपी रेटिंग", value: "IP67" },
          { label: "कूलिंग", value: "एक्टिव लिक्विड कूलिंग सिस्टम" },
        ],
        motor: [
          { label: "प्रकार", value: "PMSM (स्थायी चुंबक सिंक्रोनस मोटर)" },
          { label: "पीक पावर", value: "45 kW (55 HP के बराबर)" },
          { label: "पीक टॉर्क", value: "410 NM" },
          { label: "रेटेड RPM", value: "2200 RPM" },
          { label: "कूलिंग", value: "वाटर कूल्ड मोटर" },
          { label: "पीक दक्षता", value: "96%" },
        ],
        applications: [
          "बड़े पैमाने पर व्यावसायिक कृषि संचालन",
          "भारी मिट्टी की जुताई और गहरी जुताई",
          "औद्योगिक सामग्री प्रबंधन और रसद",
          "18 टन पेलोड तक भारी ढुलाई",
          "निर्माण स्थल संचालन",
          "नगर निगम और सरकारी बेड़े संचालन",
        ],
        highlights: [
          "ऑटोनेक्स्ट की श्रृंखला में सबसे शक्तिशाली इलेक्ट्रिक ट्रैक्टर",
          "63.89 kwh लिक्विड-कूल्ड LFP बैटरी — रेटेड लोड के साथ 80 किमी रेंज",
          "Carraro ट्रांसमिशन के साथ 410 NM पीक टॉर्क",
          "डुअल चार्जिंग: AC फास्ट 13.2 kW + DC फास्ट 40 kW DUAL Gun",
          "2800 kg हाइड्रोलिक लिफ्टिंग क्षमता",
          "5-साल की बैटरी वारंटी 1500 चार्ज साइकल के साथ",
          "भारत में निर्मित — ठाणे, महाराष्ट्र",
        ],
      },
      x45c2: {
        name: "AutoNxt X45C2",
        type: "45HP इलेक्ट्रिक ट्रैक्टर",
        badge: "उच्च दक्षता",
        badgeColor: "bg-emerald-700",
        tagline: "व्यावसायिक स्तर का उच्च दक्षता इलेक्ट्रिक ट्रैक्टर",
        desc: "X45C2 ऑटोनेक्स्ट का उच्च दक्षता वाला कृषि और औद्योगिक इलेक्ट्रिक ट्रैक्टर है। व्यावसायिक खेती और भारी-ड्यूटी औद्योगिक कार्यों के लिए इंजीनियर किया गया, इसमें 32 kW की PMSM इलेक्ट्रिक मोटर, 38.4 kWh LFP04 प्रिज़मेटिक बैटरी पैक और रेटेड लोड के साथ 60 किमी की रेंज है। सबसे कठिन वातावरण के लिए चरम टॉर्क और शून्य सीधे उत्सर्जन देने के लिए डिज़ाइन किया गया है।",
        image: "/3dmodel/x45.glb",
        glbSrc: "/3dmodel/x45.glb",
        status: "available",
        specs: [
          { label: "मोटर शक्ति", value: "32 kW (45 HP), PMSM" },
          { label: "बैटरी क्षमता", value: "[Lithium Ferro Phosphate] LFP04 प्रिज़मेटिक, 38.4 kWh" },
          { label: "रेंज", value: "रेटेड लोड के साथ 60 किमी" },
          { label: "चार्जर", value: "AC स्लो 6.6 kW (ऑनबोर्ड) + AC फास्ट 13.2 kW (ऑफ-बोर्ड)" },
          { label: "अधिकतम टॉर्क", value: "223 NM" },
          { label: "वजन", value: "~2.3 टन" },
          { label: "उठाने की क्षमता", value: "1800 kg" },
          { label: "अधिकतम गति", value: "35 किमी/घंटा" },
          { label: "पीटीओ शक्ति", value: "24.5 kW / 32.8 HP, 540E और 540 RPM" },
          { label: "कूलिंग", value: "वाटर कूल्ड मोटर" },
          { label: "ट्रांसमिशन", value: "Constant Mesh (Carraro), 1800 RPM" },
          { label: "वारंटी", value: "मोटर 3+2 वर्ष, बैटरी 1500 साइकिल/5 वर्ष" },
        ],
        features: [
          {
            title: "LFP04 प्रिज़मेटिक बैटरी पैक",
            desc: "अत्यधिक मौसम में स्थिर बिजली आपूर्ति प्रदान करने के लिए 38.4 kWh क्षमता और 1500+ लंबे जीवन चक्र के साथ उन्नत LFP04 प्रिज़मेटिक बैटरी रसायन।"
          },
          {
            title: "रिमोट फ्लीट टेलीमैटिक्स",
            desc: "वास्तविक समय जीपीएस ट्रैकिंग, बैटरी की स्थिति, मोटर स्वास्थ्य और ऑटोनेक्स्ट क्लाउड प्लेटफॉर्म के माध्यम से जियो-फेंसिंग — किसी भी डिवाइस से सुलभ।"
          },
        ],
        battery: [
          { label: "रसायन शास्त्र", value: "लिथियम आयरन फॉस्फेट (LFP04 प्रिज़मेटिक)" },
          { label: "क्षमता", value: "38.4 kWh" },
          { label: "सेल साइकिल लाइफ", value: "1500 चार्जिंग - डिस्चार्ज साइकल" },
          { label: "वारंटी", value: "5 वर्ष / 1500 साइकल (जो भी पहले हो)" },
          { label: "ऑनबोर्ड चार्जर", value: "हाँ (6.6 kW AC स्लो चार्जर अंतर्निहित)" },
        ],
        motor: [
          { label: "प्रकार", value: "PMSM (स्थायी चुंबक सिंक्रोनस मोटर)" },
          { label: "मोटर शक्ति", value: "32 kW (45 HP)" },
          { label: "अधिकतम टॉर्क", value: "223 NM" },
          { label: "कूलिंग", value: "वाटर कूल्ड मोटर" },
        ],
        applications: [
          "मध्यम-से-भारी स्तर के कृषि कार्य",
          "मिट्टी की जुताई और बीज रोपण",
          "10 टन तक का परिवहन और पेलोड हैंडलिंग",
          "बागवानी, दाख की बारियां और पंक्ति फसल प्रबंधन",
          "औद्योगिक संयंत्र आंतरिक रसद",
        ],
        highlights: [
          "ऑटोनेक्स्ट का उच्च दक्षता वाला हेवी-ड्यूटी इलेक्ट्रिक ट्रैक्टर",
          "38.4 kWh LFP04 प्रिज़मेटिक बैटरी पैक के साथ अधिकतम रनटाइम",
          "वाटर कूल्ड PMSM मोटर — 32 kW / 45 HP",
          "10 टन अधिकतम रेटेड लोड पेलोड संभालने में सक्षम",
          "मोटर 3+2 वर्ष | बैटरी 1500 साइकल/5 वर्ष वारंटी",
          "भारत में निर्मित — ठाणे, महाराष्ट्र",
        ],
      },
    }
  },
  industryPage: {
    metaTitle: "उद्योग के अनुसार इलेक्ट्रिक ट्रैक्टर | AutoNxt",
    metaDescription: "विभिन्न क्षेत्रों में AutoNxt इलेक्ट्रिक उपयोगिता वाहनों की खोज करें: कृषि, निर्माण, हवाई अड्डे, बायोमास, धातु और रक्षा।",
    texts: {
      indSol: "औद्योगिक समाधान",
      heroTitlePre: "भारत के सबसे कठिन उद्योगों को ",
      heroTitleHighlight: "शक्ति देना",
      heroTitlePost: "।",
      heroDesc: "इलेक्ट्रिक ट्रैक्टर समाधान जो मजबूत, शून्य-उत्सर्जन और भारत के सबसे कठिन वातावरण के लिए बनाए गए हैं।",
      industriesLabel: "उद्योग",
      applicationsLabel: "अनुप्रयोग",
      certifiedLabel: "प्रमाणित",
      ourSolutions: "हमारे समाधान",
      solHeading: "छह उद्योग। एक ईवी प्लेटफॉर्म।",
      solDesc: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर भारत के सबसे कठिन वातावरणों में निरंतर कार्यभार के लिए बनाए गए हैं।",
      learnMore: "अधिक जानें",
      ourTractors: "हमारे ट्रैक्टर",
      tractorsHeading: "हर काम के लिए सही ट्रैक्टर।",
      tractorsDesc: "औद्योगिक और कृषि कार्यों के लिए विशेष रूप से निर्मित इलेक्ट्रिक ट्रैक्टरों की हमारी बढ़ती श्रृंखला में से चुनें।",
      electricTractor: "इलेक्ट्रिक ट्रैक्टर",
      viewDetails: "विवरण देखें",
      dontSeeSector: "अपना क्षेत्र नहीं दिख रहा है?",
      ctaDesc: "हमारा प्लेटफॉर्म असीमित रूप से अनुकूलनीय है। कस्टम औद्योगिक साझेदारी के बारे में जानने के लिए हमारी टीम से बात करें।",
      talkToUs: "हमसे बात करें",
    },
    industries: [
      {
        title: "बायोमास",
        slug: "biomass",
        short: "BIO",
        desc: "शून्य उत्सर्जन और कम परिचालन लागत के साथ बायोमास संग्रह, प्रसंस्करण और परिवहन में क्रांति लाकर एक हरित भविष्य का निर्माण करें।",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर बायोमास संचालन में दक्षता को फिर से परिभाषित करते हैं। बायोमास संग्रह, प्रसंस्करण और परिवहन के लिए डिज़ाइन किए गए हमारे ट्रैक्टर हर चक्र में विश्वसनीयता और स्थिरता प्रदान करते हैं।",
        bg: "bg-lime-700",
        img: "/images/doubletrolleysidedroneview.webp",
      },
      {
        title: "सीमेंट निर्माण",
        short: "CEMENT",
        slug: "cement",
        desc: "सीमेंट संयंत्रों में सामग्री प्रबंधन, परिवहन और साइट रखरखाव को अनुकूलित करें — डाउनटाइम को कम करें और उत्पादकता बढ़ाएं।",
        detail: "सीमेंट निर्माण में ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टरों की शक्ति का अनुभव करें। हमारे ट्रैक्टर शून्य उत्सर्जन और उन्नत सुविधाओं के साथ सामग्री प्रबंधन, परिवहन और साइट रखरखाव को अनुकूलित करते हैं।",
        bg: "bg-orange-700",
        img: "/images/cement_industry.webp",
      },
      {
        title: "निर्माण उद्योग",
        short: "CONST.",
        slug: "construction",
        desc: "साइट की तैयारी, सामग्री प्रबंधन और उपकरण परिवहन के लिए बेजोड़ बहुमुखी प्रतिभा और शक्ति — हरित निर्माण का मार्ग प्रशस्त करें।",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर निर्माण का भविष्य हैं। बेजोड़ बहुमुखी प्रतिभा और शक्ति के साथ, वे साइट की तैयारी, सामग्री प्रबंधन और उपकरण परिवहन में उत्कृष्ट प्रदर्शन करते हैं।",
        bg: "bg-yellow-700",
        img: "/images/construction_industry.webp",
      },
      {
        title: "रक्षा क्षेत्र",
        short: "DEF.",
        slug: "defence",
        desc: "सैन्य रसद, बेस रखरखाव और ऑल-टेरेन संचालन के लिए उत्कृष्ट प्रदर्शन और मजबूत स्थायित्व, रिमोट ऑपरेशन के विकल्पों के साथ।",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर रक्षा अनुप्रयोगों के लिए उत्कृष्ट प्रदर्शन और मजबूत स्थायित्व प्रदान करते हैं। लॉजिस्टिक्स समर्थन से लेकर बेस रखरखाव तक, वे सबसे कठिन सैन्य वातावरण में उत्कृष्ट प्रदर्शन करते हैं।",
        bg: "bg-slate-700",
        img: "/images/implements.webp",
      },
      {
        title: "हवाई अड्डा संचालन",
        short: "AIRPORT",
        slug: "airport",
        desc: "सामान संभालने से लेकर रनवे के रखरखाव तक — सुगम और पर्यावरण-आनुकूल हवाई अड्डा संचालन के लिए शून्य-उत्सर्जन, स्वायत्त-तैयार ट्रैक्टर।",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर हवाई अड्डे के संचालन को फिर से परिभाषित करते हैं। सामान संभालने से लेकर रनवे रखरखाव तक, हमारे ट्रैक्टर शून्य उत्सर्जन और उन्नत स्वायत्त नेविगेशन सुविधाएँ प्रदान करते हैं।",
        bg: "bg-sky-700",
        img: "/images/facility/garage-entry.webp",
      },
      {
        title: "धातु निर्माण",
        short: "METAL",
        slug: "metal",
        desc: "सामग्री प्रबंधन से लेकर रसद तक, हमारे ट्रैक्टर पर्यावरण पर प्रभाव को कम करते हुए धातु निर्माण कार्यों को सुव्यवस्थित करते हैं।",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर धातु निर्माण में दक्षता को फिर से परिभाषित करते हैं। सामग्री प्रबंधन से लेकर रसद तक, हमारे ट्रैक्टर पर्यावरणीय प्रभाव को कम करते हुए संचालन को सुव्यवस्थित करते हैं।",
        bg: "bg-slate-600",
        img: "/images/videos/loaders-grabbers-thumbnail.webp",
      },
    ],
    tractors: [
      {
        img: "/images/products/x45h2.webp",
        name: "AutoNxt X45H2",
        slug: "x45h2",
        hp: "45HP",
        status: "available",
        statusLabel: "अभी उपलब्ध है",
        desc: "खेती और निर्माण के लिए उपयुक्त एक शक्तिशाली 45HP ट्रैक्टर। पारंपरिक 35-55 HP डीजल ट्रैक्टरों के प्रदर्शन से मेल खाते हुए, कृषि और ढुलाई गतिविधियों की एक विस्तृत श्रृंखला के लिए आदर्श।",
        specs: [
          { label: "मोटर", value: "32 kW" },
          { label: "बैटरी", value: "38.4 kWh" },
          { label: "रेंज", value: "50 km" },
        ],
        accentBg: "bg-primary/5",
        accentBorder: "border-primary/20",
        tagColor: "bg-emerald-500",
      },
      {
        img: "/images/products/h55c2.webp",
        name: "AutoNxt H55C2",
        slug: "h55c2",
        hp: "55HP Equivalent",
        status: "available",
        statusLabel: "अभी उपलब्ध है",
        desc: "63.89 kwh लिक्विड-कूल्ड LFP बैटरी, कैरारो ट्रांसमिशन, 410 NM टॉर्क और 80 किमी रेंज के साथ उच्च प्रदर्शन वाला 55HP समकक्ष इलेक्ट्रिक ट्रैक्टर। भारी कृषि और औद्योगिक कार्यों के लिए निर्मित।",
        specs: [
          { label: "मोटर", value: "45 kW" },
          { label: "बैटरी", value: "63.89 kwh" },
          { label: "रेंज", value: "80 km" },
        ],
        accentBg: "bg-accent/5",
        accentBorder: "border-accent/20",
        tagColor: "bg-accent",
      },
      {
        img: "/images/products/x45h2.webp",
        name: "AutoNxt X45C2",
        slug: "x45c2",
        hp: "45HP",
        status: "available",
        statusLabel: "अभी उपलब्ध है",
        desc: "वाणिज्यिक कार्यों के लिए उन्नत सुविधाओं के साथ उच्च दक्षता वाला 45HP ट्रैक्टर। विश्वसनीयता और शून्य-उत्सर्जन स्थिरता का एक आदर्श संतुलन।",
        specs: [
          { label: "मोटर", value: "32 kW" },
          { label: "बैटरी", value: "38.4 kWh" },
          { label: "रेंज", value: "60 km" },
        ],
        accentBg: "bg-primary/5",
        accentBorder: "border-primary/20",
        tagColor: "bg-emerald-500",
      },
    ]
  },
  industryDetailPage: {
    texts: {
      industryNotFound: "उद्योग नहीं मिला",
      backToIndustries: "← उद्योगों पर वापस जाएं",
      allIndustries: "सभी उद्योग",
      overview: "अवलोकन",
      challenge: "चुनौती",
      theAutoNxtSolution: "ऑटोनेक्स्ट समाधान",
      keyApplications: "मुख्य अनुप्रयोग",
      whatAutoNxtDoes: "ऑटोनेक्स्ट यहाँ क्या करता है",
      whyAutoNxt: "क्यों ऑटोनेक्स्ट",
      builtFor: "के लिए निर्मित।",
      electricMotor: "इलेक्ट्रिक मोटर",
      torque0Rpm: "0 आरपीएम से तत्काल पूर्ण टॉर्क",
      batteryRange: "बैटरी रेंज",
      perChargeDuty: "निरंतर कर्तव्य चक्र में प्रति चार्ज",
      chargeTime: "चार्ज समय",
      acChargingStandard: "मानक औद्योगिक आपूर्ति से एसी चार्जिंग",
      fleetSupport: "बेड़े का समर्थन",
      remoteDiagnostics: "रिमोट डायग्नोस्टिक्स और टेलीमैटिक्स",
      recommendedModels: "अनुशंसित मॉडल",
      rightTractorFor: "के लिए सही ट्रैक्टर",
      viewFullSpecs: "पूर्ण विवरण देखें",
      readyToGoElectric: "में इलेक्ट्रिक जाने के लिए तैयार हैं?",
      ctaDesc: "हमारी औद्योगिक समाधान टीम से बात करें। हम बेड़े की आवश्यकताओं, चार्जिंग बुनियादी ढांचे और टीसीओ बचत का आकलन करने में आपकी सहायता करेंगे।",
      bookConsultation: "परामर्श बुक करें",
    },
    industries: {
      biomass: {
        title: "बायोमास",
        badge: "BIOMASS",
        tagline: "शून्य-उत्सर्जन बायोमास संग्रह और प्रसंस्करण",
        desc: "भारत सालाना 50 करोड़ टन से अधिक कृषि बायोमास उत्पन्न करता है। ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर बायोमास संग्रह, बेलिंग, परिवहन और प्रसंस्करण की विशिष्ट मांगों के लिए इंजीनियर किए गए हैं — जो भंडारण और प्रसंस्करण सुविधाओं के अंदर उच्च अपटाइम, कम प्रति-टन लागत और शून्य निकास उत्सर्जन प्रदान करते हैं।",
        bg: "bg-lime-700",
        image: "/images/doubletrolleysidedroneview.webp",
        applications: [
          {
            title: "बायोमास ढुलाई",
            desc: "बिना किसी गर्मी और डीजल निकास के बंद बायोमास बेज़ में लोड किए गए बायोमास ट्रेलरों को लगातार उच्च टॉर्क के साथ खींचें।"
          },
          {
            title: "बेलिंग संचालन",
            desc: "लगातार पीटीओ आउटपुट के साथ राउंड और स्क्वायर बेलर चलाएं। इलेक्ट्रिक टॉर्क कर्व बिना इंजन बंद हुए बेलर की मांग के लिए आदर्श है।"
          },
          {
            title: "संयंत्र के भीतर परिवहन",
            desc: "प्रसंस्करण संयंत्रों के भीतर बायोमास बेलों को ले जाएं जहां डीजल का धुआं स्वास्थ्य के लिए खतरा है। ऑटोनेक्स्ट का शून्य-उत्सर्जन संचालन इन बंद वातावरणों के लिए सुरक्षित है।"
          },
          {
            title: "खेत संग्रह",
            desc: "प्रति चार्ज 8+ घंटे के रनटाइम के साथ खेतों से संग्रह। स्मार्ट टेलीमैटिक्स संग्रह मार्गों को अनुकूलित करता है।"
          },
        ],
        benefits: [
          "5 वर्षों में डीजल की तुलना में 70% कम परिचालन लागत",
          "शून्य धुआं — इनडोर बायोमास भंडारण और प्रसंस्करण के लिए सुरक्षित",
          "प्रति चार्ज 10 घंटे / 10 एकड़ निरंतर संचालन",
          "व्यावसायिक कृषि उपयोग के लिए iCAT प्रमाणित",
          "सौर चार्जिंग ग्रिड निर्भरता को कम करती है",
          "ऑटोनेक्स्ट टेलीमैटिक्स पोर्टल के माध्यम से रिमोट बेड़े की निगरानी",
        ],
        challenges: "बायोमास संचालन लंबी पालियों में चलता है, अक्सर उन शेडों के अंदर जहां डीजल का धुआं हवा की गुणवत्ता और आग के गंभीर जोखिम पैदा करता है। उच्च ईंधन लागत मार्जिन को कम करती है, और कटाई के मौसम में अनियोजित रखरखाव पूरी आपूर्ति श्रृंखला को बाधित करता है।",
        solution: "ऑटोनेक्स्ट X45H2 शून्य निकास उत्सर्जन के साथ 45HP का तत्काल इलेक्ट्रिक टॉर्क प्रदान करता है, जिससे यह बायोमास प्रसंस्करण सुविधाओं के अंदर सुरक्षित हो जाता है। 10 घंटे के रनटाइम और 4 घंटे के चार्ज चक्र के साथ, सुविधाएं रात की चार्जिंग का उपयोग करके एक ही ट्रैक्टर के साथ दो शिफ्ट चला सकती हैं।",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "बायोमास ढुलाई और बेलिंग के लिए प्राथमिक विकल्प", slug: "x45h2" },
          { name: "AutoNxt H55C2", hp: "55 HP", img: "/images/products/h55c2.webp", note: "भारी बायोमास संग्रह और औद्योगिक कार्यों के लिए उच्च-प्रदर्शन विकल्प", slug: "h55c2" },
        ],
      },
      cement: {
        title: "सीमेंट निर्माण",
        badge: "CEMENT",
        tagline: "स्वच्छ, शांत सीमेंट संयंत्र संचालन",
        desc: "सीमेंट संयंत्र धूल-भारी, शोर-गहन और ईंधन-निर्भर वातावरण हैं। ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर आंतरिक रसद को बदलते हैं — कच्चे माल के प्रबंधन से लेकर क्लिंकर परिवहन तक — परिचालन उत्सर्जन को कम करते हैं और नाटकीय रूप से परिचालन लागत को कम करते हैं।",
        bg: "bg-orange-700",
        image: "/images/cement_industry.webp",
        applications: [
          {
            title: "कच्चा माल रसद",
            desc: "संयंत्र गलियारों में चूना पत्थर, मिट्टी और एडिटिव्स का परिवहन करें। डीजल टर्बुलेंस की तुलना में इलेक्ट्रिक ऑपरेशन धूल के दोबारा उड़ने को कम करता है।"
          },
          {
            title: "क्लिंकर परिवहन",
            desc: "उच्च तापमान वाले क्षेत्रों में लगातार उच्च-टॉर्क क्षमता और बिना किसी ओवरहीटिंग की चिंता के भट्टियों, कूलरों और साइलो के बीच क्लिंकर को ले जाएं।"
          },
        ],
        benefits: [
          "बंद संयंत्र गलियारों में डीजल निकास को समाप्त करता है",
          "कम शोर 24/7 संयंत्र वातावरण में श्रमिकों की थकान को कम करता है",
          "कोई हाइड्रोलिक तेल रिसाव नहीं — सीमेंट भंडारण क्षेत्रों के पास महत्वपूर्ण",
          "भारी औद्योगिक तैनाती के लिए iCAT प्रमाणित",
          "ओटीए सॉफ्टवेयर अपडेट प्रदर्शन को इष्टतम रखते हैं",
          "बेड़े टेलीमैटिक्स संयंत्र प्रबंधन प्रणालियों के साथ एकीकृत होता है",
        ],
        challenges: "सीमेंट संयंत्र केवल आंतरिक रसद में प्रति माह हजारों लीटर डीजल की खपत करते हैं। उच्च परिवेश तापमान डीजल इंजनों को गर्म करने का कारण बनता है। उत्सर्जन नियम कड़े हो रहे हैं।",
        solution: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर कोई निकास उत्पन्न नहीं करते हैं और उच्च-परिवेश वातावरण में ठंडे चलते हैं। मॉड्यूलर बैटरी आर्किटेक्चर के साथ, पूरे ट्रैक्टर को ऑफलाइन लिए बिना बैटरी पैक की सर्विस की जा सकती है।",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "क्लिंकर परिवहन और भारी ढुलाई के लिए अनुशंसित", slug: "x45h2" },
        ],
      },
      construction: {
        title: "निर्माण उद्योग",
        badge: "CONSTRUCTION",
        tagline: "भारत के बिल्डिंग बूम के लिए सतत शक्ति",
        desc: "भारत का निर्माण क्षेत्र हर साल लाखों वर्ग मीटर का निर्माण करता है। ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर साइट की तैयारी, सामग्री परिवहन और उपकरण स्थिति के लिए शून्य-उत्सर्जन, उच्च-टॉर्क प्रदर्शन लाते हैं।",
        bg: "bg-yellow-700",
        image: "/images/construction_industry.webp",
        applications: [
          {
            title: "सामग्री ढुलाई",
            desc: "एक स्थिर, उच्च-टॉर्क इलेक्ट्रिक ड्राइवट्रेन के साथ सक्रिय निर्माण स्थलों पर रेत, गिट्टी, ईंटों और स्टील सुदृढीकरण का परिवहन करें।"
          },
        ],
        benefits: [
          "हरित भवन साइट उत्सर्जन मानकों को पूरा करता है",
          "कम शोर — आवासीय साइट कार्य समय प्रतिबंधों का अनुपालन करता है",
          "असमान और बजरी वाली सतहों के लिए मजबूत चेसिस",
          "ढलान पर भार खींचने के लिए आदर्श त्वरित टॉर्क",
          "साइट पर कोई ईंधन भंडारण जोखिम नहीं — आग के खतरे को कम करता है",
        ],
        challenges: "निर्माण स्थलों को विशेष रूप से शहरी आवासीय क्षेत्रों के पास डीजल उत्सर्जन पर बढ़ते नियामक दबाव का सामना करना पड़ता है। ईंधन रसद जटिल है।",
        solution: "ऑटोनेक्स्ट X45H2 का सीलबंद इलेक्ट्रिक ड्राइवट्रेन धूल के प्रवेश से अप्रभावित रहता है। इसे किसी ईंधन वितरण की आवश्यकता नहीं होती है और बैटरी को साइट की अस्थायी बिजली आपूर्ति से चार्ज किया जा सकता है।",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "निर्माण स्थल ढुलाई और मिट्टी की तैयारी के लिए प्राथमिक विकल्प", slug: "x45h2" },
        ],
      },
      defence: {
        title: "रक्षा क्षेत्र",
        badge: "DEFENCE",
        tagline: "शांत। मजबूत। मिशन के लिए तैयार।",
        desc: "रक्षा और अर्धसैनिक संचालन ऐसे उपकरणों की मांग करते हैं जो दबाव में विश्वसनीय हों, और कम ध्वनिक और थर्मल हस्ताक्षर वाले हों। ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर बेस लॉजिस्टिक्स, एयरफील्ड सपोर्ट और ऑल-टेरेन उपयोगिता के लिए इंजीनियर किए गए हैं।",
        bg: "bg-slate-700",
        image: "/images/implements.webp",
        applications: [
          {
            title: "बेस्स लॉजिस्टिक्स",
            desc: "शून्य ध्वनिक हस्ताक्षर के साथ बेस सुविधाओं के बीच आपूर्ति और उपकरणों को ले जाएं जो सुरक्षा परिधि को बढ़ाए।"
          },
        ],
        benefits: [
          "कम-मूक इलेक्ट्रिक संचालन ध्वनिक पहचान को कम करता है",
          "निकास से कोई थर्मल पहचान नहीं — सुरक्षा में सुधार",
          "शॉर्ट-रेंज बेस लॉजिस्टिक्स के लिए ईंधन निर्भरता समाप्त करता है",
          "कच्चे और ऑफ-रोड इलाके के लिए मजबूत चेसिस",
          "कम रखरखाव बोझ — कोई इंजन तेल, फिल्टर या इंजेक्टर नहीं",
        ],
        challenges: "रक्षा रसद को ऐसे उपकरणों की आवश्यकता होती है जो जटिल ईंधन रसद के बिना, विविध इलाकों में चुपचाप काम कर सकें।",
        solution: "ऑटोनेक्स्ट का इलेक्ट्रिक पावरट्रेन मूक संचालन करता है और कोई थर्मल हस्ताक्षर नहीं बनाता है, जो बेस परिधि संचालन के लिए आदर्श है। बैटरी को सौर ऊर्जा से भी चार्ज किया जा सकता है।",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "रक्षा बेस लॉजिस्टिक्स के लिए प्राथमिक सिफारिश", slug: "x45h2" },
        ],
      },
      airport: {
        title: "हवाई अड्डा संचालन",
        badge: "AIRPORT",
        tagline: "भारतीय हवाई अड्डों के लिए हरित भू-संचालन",
        desc: "हवाई अड्डों पर जमीनी स्तर के उत्सर्जन को कम करने का तीव्र दबाव है। ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर सामान संभालने, रनवे के रखरखाव, कार्गो आंदोलन और परिधि संचालन के लिए आदर्श हैं।",
        bg: "bg-sky-700",
        image: "/images/facility/garage-entry.webp",
        applications: [
          {
            title: "सामान और कार्गो ढुलाई",
            desc: "यात्री और चालक दल के पास शून्य उत्सर्जन के साथ Terminलों, विमानों और कार्गो बे के बीच सामान के ट्रेलरों को खींचें।"
          },
        ],
        benefits: [
          "DGCA और ICAO ग्राउंड उत्सर्जन मानकों को पूरा करता है",
          "शांत संचालन ATC संचार वातावरण में सुधार करता है",
          "शून्य धुआं — विमानन ईंधन भंडारों के पास महत्वपूर्ण",
          "ग्रीन ग्राउंड संचालन अनुदान के लिए पात्र",
          "बेड़े टेलीमैटिक्स हवाई अड्डा संचालन केंद्रों के साथ एकीकृत होता है",
        ],
        challenges: "हवाई अड्डों को जमीनी स्तर के उत्सर्जन पर सख्त नियमों का सामना करना पड़ता है। ईंधन डिपो के पास डीजल वाहन आग का खतरा पैदा करते हैं।",
        solution: "ऑटोनेक्स्ट के शून्य-उत्सर्जन, शांत इलेक्ट्रिक ट्रैक्टर हवाई अड्डे के संवेदनशील वातावरण के लिए आदर्श हैं। उन्हें रात में चार्ज किया जा सकता है और क्लाउड से ट्रैक किया जा सकता है।",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "सामान ढुलाई और रनवे रखरखाव के लिए अनुशंसित", slug: "x45h2" },
        ],
      },
      metal: {
        title: "धातु निर्माण",
        badge: "METAL",
        tagline: "धातु संयंत्रों के लिए भारी-ड्यूटी इलेक्ट्रिक रसद",
        desc: "धातु निर्माण सुविधाओं को गहन आंतरिक रसद की आवश्यकता होती है। ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर उच्च टॉर्क के साथ भारी सामग्री ढुलाई का प्रबंधन करते हैं, जबकि बंद कारखाने के वातावरण में डीजल के धुएं को समाप्त करते हैं।",
        bg: "bg-slate-600",
        image: "/images/videos/loaders-grabbers-thumbnail.webp",
        applications: [
          {
            title: "कॉइल और शीट ढुलाई",
            desc: "भारी ट्रेलर लोड के लिए आवश्यक उच्च टॉर्क के साथ संयंत्र रसद गलियारों में स्टील कॉइल और शीट का परिवहन करें।"
          },
        ],
        benefits: [
          "बंद गलन और रोलिंग वातावरण में डीजल के धुएं को समाप्त करता है",
          "भारी धातु ट्रेलर लोड के लिए निरंतर उच्च टॉर्क",
          "उच्च धूल वाले वातावरण के लिए आईपी-रेटेड बैटरी सुरक्षा",
          "ज्वलनशील धातु प्रसंस्करण एजेंटों के पास आग के खतरे को कम करता है",
          "संयंत्र-स्तर की बिजली प्रबंधन प्रणालियों के साथ संगत",
        ],
        challenges: "धातु संयंत्रों को अत्यधिक गर्मी, धूल और सख्त हवा की गुणवत्ता आवश्यकताओं का सामना करना पड़ता है। डीजल का धुआं स्वास्थ्य के लिए गंभीर खतरा पैदा करता है।",
        solution: "ऑटोनेक्स्ट X45H2 का सीलबंद इलेक्ट्रिक पावरट्रेन धूल के प्रवेश से सुरक्षित है। लिक्विड-कूल्ड बैटरी पैक ओवरहीटिंग की समस्याओं के बिना इष्टतम तापमान बनाए रखता है।",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "धातु संयंत्र ढुलाई और रसद के लिए प्राथमिक विकल्प", slug: "x45h2" },
        ],
      },
    }
  },
  careersPage: {
    texts: {
      careersBadge: "ऑटोनेक्स्ट में करियर",
      heroTitle1: "खेती का ",
      heroTitleHighlight: "भविष्य",
      heroTitle2: " बनाएं।",
      heroDesc: "उन इंजीनियरों, कृषिविदों और व्यवसाय निर्माताओं की टीम में शामिल हों जो भारतीय कृषि का विद्युतीकरण कर रहे हैं — एक समय में एक ट्रैक्टर।",
      openRolesLabel: "खुले पद",
      locationsLabel: "स्थान",
      teamSizeLabel: "टीम का आकार",
      positionsCount: " पद उपलब्ध",
      locationsVal: "ठाणे · मुंबई",
      teamSizeVal: "150+ लोग",
      whyJoinUs: "हमारे साथ क्यों जुड़ें",
      workOnProblems: "उन समस्याओं पर काम करें जो मायने रखती हैं।",
      whyJoinUsDesc: "ऑटोनेक्स्ट भारत की सबसे गंभीर चुनौतियों में का सामना कर रहा है — कृषि को लाखों किसानों के लिए टिकाऊ और आर्थिक रूप से व्यावहारिक बनाना।",
      openPositions: "खुली नौकरियां",
      rolesAvailable: " रिक्तियां अभी उपलब्ध हैं",
      applyViaEmail: "ईमेल के माध्यम से आवेदन करें",
      dontSeeRole: "क्या आपको अपनी मनपसंद भूमिका नहीं दिख रही है?",
      dontSeeRoleDesc: "हम हमेशा असाधारण प्रतिभाओं की तलाश में रहते हैं। हमें अपना सीवी भेजें और बताएं कि आप ऑटोनेक्स्ट के मिशन में कैसे योगदान देंगे।",
      sendOpenApp: "आवेदन पत्र भेजें",
    },
    perks: [
      { title: "मिशन-संचालित कार्य", desc: "भारतीय कृषि को कार्बन मुक्त करने में मदद करें — आपके द्वारा बनाया गया प्रत्येक उत्पाद वास्तविक पर्यावरणीय प्रभाव डालता है।", color: "text-primary", bg: "bg-primary/10", border: "border-primary/20" },
      { title: "स्टार्टअप गति", desc: "सपाट संरचना, त्वरित निर्णय और पहले दिन से ही महत्वपूर्ण व्यावसायिक चुनौतियों का स्वामित्व लेने का अवसर।", color: "text-accent", bg: "bg-accent/10", border: "border-accent/20" },
      { title: "गहन क्षेत्रीय अनुभव", desc: "हमारे इंजीनियर नियमित रूप से महाराष्ट्र, पंजाब और आंध्र प्रदेश के खेतों का दौरा करते हैं — आप उस समस्या को करीब से समझेंगे जिसे आप हल कर रहे हैं।", color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200" },
      { title: "इक्विटी और विकास", desc: "प्रतिस्पर्धी मुआवजा, प्रमुख भूमिकाओं के लिए ईएसओपी और ऑटोनेक्स्ट के राष्ट्रीय स्तर पर बढ़ने के साथ-साथ विकास का स्पष्ट मार्ग।", color: "text-rose-600", bg: "bg-rose-50", border: "border-rose-200" },
    ],
    roles: [
      {
        title: "वरिष्ठ एंबेडेड सिस्टम्स इंजीनियर",
        dept: "इंजीनियरिंग",
        location: "ठाणे, महाराष्ट्र",
        type: "पूर्णकालिक",
        desc: "ऑटोनेक्स्ट के इलेक्ट्रिक पावरट्रेन, बीएमएस और कैन बस संचार प्रणालियों के लिए फर्मवेयर डिजाइन और विकसित करें। सी/सी++ और रीयल-टाइम ओएस में मजबूत अनुभव आवश्यक है।",
      },
      {
        title: "मैकेनिकल डिजाइन इंजीनियर - ड्राइवट्रेन",
        dept: "इंजीनियरिंग",
        location: "ठाणे, महाराष्ट्र",
        type: "पूर्णकालिक",
        desc: "ट्रैक्टर ड्राइवट्रेन, गियरबॉक्स और इम्प्लीमेंट कपलिंग सिस्टम के मैकेनिकल डिजाइन का नेतृत्व करें। सॉलिडवर्क्स में दक्षता और व्यावहारिक निर्माण अनुभव को प्राथमिकता दी जाएगी।",
      },
      {
        title: "कृषि क्षेत्र इंजीनियर",
        dept: "संचालन",
        location: "अखिल भारतीय (यात्रा)",
        type: "पूर्णकालिक",
        desc: "ऑटोनेक्स्ट ट्रैक्टरों को तैनात करने, क्षेत्र प्रदर्शन डेटा एकत्र करने और पूरे भारत में तकनीकी सहायता प्रदान करने के लिए किसानों और कृषि-औद्योगिक ग्राहकों के साथ सीधे काम करें।",
      },
      {
        title: "व्यापार विकास प्रबंधक - कृषि क्षेत्र",
        dept: "विक्रय",
        location: "पुणे / नासिक",
        type: "पूर्णकालिक",
        desc: "बड़े खेतों, चीनी मिलों और कृषि-औद्योगिक ग्राहकों के साथ संबंध बनाएं और प्रबंधित करें। ट्रैक्टर बिक्री, पट्टा साझेदारी और सरकारी खरीद निविदाओं को संचालित करें।",
      },
      {
        title: "आईओटी और टेलीमैटिक्स इंजीनियर",
        dept: "इंजीनियरिंग",
        location: "ठाणे, महाराष्ट्र",
        type: "पूर्णकालिक",
        desc: "ऑटोनेक्स्ट फ्लीट टेलीमैटिक्स प्लेटफॉर्म विकसित करें — जीपीएस ट्रैकिंग, रिमोट डायग्नोस्टिक्स, ओटीए अपडेट और इन-फील्ड सेंसर से क्लाउड डैशबोर्ड तक डेटा पाइपलाइन।",
      },
      {
        title: "विपणन और सामग्री रणनीतिकार",
        dept: "विपणन",
        location: "मुंबई / रिमोट",
        type: "पूर्णकालिक",
        desc: "ऑटोनेक्स्ट की डिजिटल उपस्थिति के मालिक बनें — सामग्री विपणन, सोशल मीडिया, केस स्टडीज और एसईओ। कृषि-तकनीक या स्थिरता क्षेत्रों में अनुभव एक मजबूत प्लस है।",
      },
    ]
  },
  contributionPage: {
    metaTitle: "पर्यावरण और ESG योगदान | AutoNxt इलेक्ट्रिक ट्रैक्टर",
    metaDescription: "AutoNxt इलेक्ट्रिक ट्रैक्टरों के ESG प्रभाव, कार्बन पदचिह्न में कमी और पर्यावरणीय योगदान की खोज करें।",
    texts: {
      contribBadge: "हमारा योगदान",
      heroTitlePre: "भारत के लिए ",
      heroTitleHighlight: "निर्मित।",
      heroTitlePost: " पर्यावरण के लिए समर्पित।",
      heroDesc: "ऑटोनेक्स्ट सिर्फ एक वाहन निर्माता नहीं है। हम स्वच्छ हवा, हरित शहरों और एक स्वतंत्र इलेक्ट्रिक भविष्य के लिए भारत की प्रतिबद्धता हैं।",
      co2Label: "CO₂ बचाव",
      treesLabel: "पेड़ों के समतुल्य",
      initiativesLabel: "पहल",
      keyInitiatives: "प्रमुख पहलें",
      ourJourney: "हमारी यात्रा",
      joinMovement: "आंदोलन में शामिल हों",
      joinDesc: "भारत के स्वच्छ ऊर्जा परिवर्तन में तेजी लाने के लिए ऑटोनेक्स्ट के साथ साझेदारी करें। साथ मिलकर, हम बदलाव लाते हैं।",
      partnerBtn: "हमारे भागीदार बनें",
    },
    impacts: [
      { value: "1,500+", label: "टन CO₂ ऑफसेट", desc: "ऑटोनेक्स्ट ईवी द्वारा भारतीय सड़कों पर रोके गए जीवनकाल कार्बन उत्सर्जन।" },
      { value: "270+", label: "वाहन विद्युतीकृत", desc: "पेट्रोल और डीजल वाहनों की जगह स्वच्छ ऑटोनेक्स्ट इलेक्ट्रिक विकल्पां से बदले गए।" },
      { value: "70,650+", label: "वृक्ष समतुल्य", desc: "प्रति वर्ष कार्बन शोषण में समतुल्य पर्यावरणीय लाभ।" },
    ],
    initiatives: [
      {
        title: "परियोजना स्वच्छ गति",
        desc: "15 राज्य सरकारों के साथ साझेदारी में 2028 तक 50,000 सार्वजनिक परिवहन वाहनों को इलेक्ट्रिक करने की हमारी प्रमुख पहल।",
        badge: "सक्रिय (Active)",
      },
      {
        title: "फेम इंडिया साझेदारियां",
        desc: "भारत सरकार की फेम II योजना के साथ संरेखित, नगर पालिकाओं, एग्रीगेटर्स और व्यक्तिगत खरीदारों को रियायती ईवी समाधान प्रदान करना।",
        badge: "सरकार समर्थित",
      },
      {
        title: "आत्मनिर्भर गतिशीलता",
        desc: "100% स्वदेशी रूप से डिजाइन और निर्मित — मोटर्स से लेकर बैटरी प्रबंधन प्रणाली तक — पूरे भारत में 5,000+ कुशल नौकरियां पैदा करना।",
        badge: "मेक इन इंडिया",
      },
    ],
    stats: [
      { label: "बचत लागत", value: "₹30Cr" },
      { label: "उद्योग", value: "8 विश्वसनीय" },
      { label: "पहल", value: "3 सक्रिय" },
    ],
    timeline: [
      { year: "2019", event: "स्थापना — ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. की स्थापना पुणे, महाराष्ट्र में हुई। स्वच्छ इलेक्ट्रिक गतिशीलता की नींव रखने के लिए पहली अनुसंधान डी विकास (आरेडी) प्रयोगशाला स्थापित की गई।" },
      { year: "2020", event: "पहला प्रोटोटाइप — पहला ईवी प्रोटोटाइप सफलतापूर्वक पूरा किया गया और परीक्षा हुई। सिडबीआई से बीज फंडिंग प्राप्त हुई, जिसने आगे आरेडी को संभव बनाया।" },
      { year: "2021", event: "प्रमाणन और साझेदारी — फेम II (इलेक्ट्रिक वाहनों के तेज अडॉप्शन और निर्माण) प्रमाणन मिला। 3 राज्य सरकारों के साथ ईवी अडॉप्शन बढ़ाने हेतु साझेदारी समझौते हस्ताक्षर किए गए।" },
      { year: "2022", event: "वाणिज्यिक उत्पादन — पूर्ण पैमाने पर वाणिज्यिक उत्पादन शुरू हुआ। फ्लीट ऑपरेटरों को 500 वाहन सौंपे गए, जिसने वाणिज्यिक ईवी बाज़ार में ऑटोनेक्स्ट की शुरुआत की।" },
      { year: "2023", event: "तेज विकास — सीरीज बी फंडिंग सफलतापूर्वक जुटाई गई। ऒपरेशन 12 शहरों में फैल गए। सड़क पर 5,000+ वाहनों का मील का पत्थर हासिल किया गया।" },
      { year: "2024", event: "उपलब्धियाँ — सौर चार्जिंग नेटवर्क आधिकारिक रूप से लॉन्च किया गया। रक्षा क्षेत्र का अनुबंध हस्ताक्षरित हुआ। ऑटोनेक्स्ट ने भारत भर में 10,000+ तैनात वाहनों की ऐतिहासिक सीमा पार की।" },
      { year: "2025+", event: "वैश्विक विस्तार — अंतरराष्ट्रीय विस्तार शुरू हो गया है। सोलिड-स्टेट बैटरी पायलट प्रोजेक्ट शुरू हो गया है, जो ऑटोनेक्स्ट की स्वच्छ उर्जा यात्रा की अगली सीमा को चिह्नित करता है।" },
    ]
  },
  legalAppAffiliation: {
    bannerTitle: "AUTONXT-Attendance की आधिकारिक पृष्ठ",
    bannerDesc:
      "यह पृष्ठ AutoNxt Automation Pvt. Ltd. द्वारा प्रकाशित है, जो Google Play पर autonxtdeveloper डेवलपर खाते के तहत AUTONXT-Attendance मोबाइल ऐप का डेवलपर है।",
    appNameLabel: "ऐप का नाम",
    appNameValue: "AUTONXT-Attendance",
    developerLabel: "डेवलपर",
    developerValue: "AutoNxt Automation Pvt. Ltd.",
    playDeveloperLabel: "Google Play डेवलपर",
    playDeveloperValue: "autonxtdeveloper",
    packageIdLabel: "पैकेज ID",
    packageIdValue: "com.autonxt.attendance.app2",
    websiteLabel: "वेबसाइट",
    websiteValue: "autonxt.in",
  },
  privacyPage: {
    metaTitle: "गोपनीयता नीति — AUTONXT-Attendance | AutoNxt",
    texts: {
      legalBadge: "कानूनी",
      policyTitle: "गोपनीयता नीति — AUTONXT-Attendance",
      metaDescription:
        "AUTONXT-Attendance (com.autonxt.attendance.app2) की गोपनीयता नीति, AutoNxt Automation Pvt. Ltd. (autonxtdeveloper) द्वारा।",
      effectiveDate: "प्रभावी तिथि: 18 जून 2025 · ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड",
      policyIntro: 'ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड ("ऑटोनेक्स्ट", "हम", "हमारा", या "हमें"), AUTONXT-Attendance मोबाइल ऐप (पैकेज: com.autonxt.attendance.app2, Google Play डेवलपर: autonxtdeveloper) का डेवलपर, हमारे मोबाइल ऐप के उपयोगकर्ताओं, वेबसाइट (autonxt.in) के आगंतुकों और हमारी सेवाओं के उपयोगकर्ताओं की गोपनीयता की रक्षा के लिए प्रतिबद्ध है।',
      backToHome: "मुख्य पृष्ठ पर वापस जाएं",
      accountDeletionLink: "खाता हटाने का अनुरोध करें",
      copyright: "© 2025 ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. सर्वाधिकार सुरक्षित।",
    },
    sections: [
      {
        title: "1. जानकारी जो हम एकत्र करते हैं",
        body: `जब आप ऑटोनेक्स्ट वेबसाइट पर आते हैं, कोई पूछताछ सबमिट करते हैं, या डेमो बुक करते हैं, तो हम निम्नलिखित जानकारी एकत्र कर सकते हैं:\n• व्यक्तिगत पहचान जानकारी: नाम, ईमेल पता, फोन नंबर और संगठन का नाम।\n• उपयोग डेटा: देखे गए पृष्ठ, बिताया गया समय, ब्राउज़र प्रकार, और आईपी पता स्वचालित रूप से विश्लेषण टूल के माध्यम से एकत्र किया जाता है।\n• संचार रिकॉर्ड: हमारे संपर्क या बुकिंग फॉर्म के माध्यम से आपके द्वारा सबमिट किए गए कोई भी संदेश, प्रश्न या प्रतिक्रिया।\n\nहम सीधे भुगतान कार्ड विवरण एकत्र नहीं करते हैं; किसी भी लेनदेन को प्रमाणित भुगतान गेटवे के माध्यम से संसाधित किया जाता है।`,
      },
      {
        title: "2. हम आपकी जानकारी का उपयोग कैसे करते",
        body: `हम निम्नलिखित उद्देश्यों के लिए एकत्रित जानकारी का उपयोग करते हैं:\n• आपकी पूछताछ का उत्तर देने और उत्पाद की जानकारी या उद्धरण प्रदान करने के लिए।\n• डेमो बुकिंग, टेस्ट-ड्राइव अनुरोधों और खरीद आदेशों को संसाधित करने के लिए।\n• प्रासंगिक उत्पाद अपडेट, समाचार और ऑफ़र भेजने के लिए — केवल वहां जहां आपने ऐसे संचार प्राप्त करने के लिए सहमति दी है।\n• हमारे वेबसाइट की कार्यक्षमता और सामग्री को बेहतर बनाने के लिए समग्र, अज्ञात विश्लेषण के माध्यम से।\n• सूचना प्रौद्योगिकी अधिनियम, 2000 सहित लागू भारतीय कानून के तहत कानूनी दायित्वों का पालन करने के लिए।`,
      },
      {
        title: "3. डेटा साझा करना और प्रकटीकरण",
        body: `ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड आपके व्यक्तिगत डेटा को तीसरे पक्षों को बेचता, किराए पर या व्यापार नहीं करता है। हम निम्नलिखित सीमित परिस्थितियों में डेटा साझा कर सकते हैं:\n• अधिकृत सेवा भागीदारों (जैसे सीआरएम, ईमेल और क्लाउड होस्टिंग प्रदाता) के साथ जो गोपनीयता समझौतों के तहत विशेष रूप से हमारी ओर से डेटा संसाधित करते हैं।\n• कानून या अदालती आदेश द्वारा आवश्यक होने पर सरकारी अधिकारियों या नियामक निकायों के साथ।\n• विलय, अधिग्रहण या संपत्ति की बिक्री की स्थिति में, जिस स्थिति में उपयोगकर्ताओं को किसी भी हस्तांतरण से पहले अधिसूचित किया जाएगा।`,
      },
      {
        title: "4. डेटा अवधारण (Data Retention)",
        body: `हम आपके व्यक्तिगत डेटा को केवल तब तक बनाए रखते हैं जब तक कि उस उद्देश्य को पूरा करने के लिए आवश्यक हो जिसके लिए इसे एकत्र किया गया था, या लागू कानून द्वारा आवश्यक हो। पूछताछ रिकॉर्ड आमतौर पर 3 साल तक रखे जाते हैं। आप software-admin@autonxt.in पर हमसे संपर्क करके किसी भी समय अपने डेटा को हटाने का अनुरोध कर सकते हैं।`,
      },
      {
        title: "5. कुकीज़ और ट्रैकिंग",
        body: `हमारी वेबसाइट आपके ब्राउज़िंग अनुभव को बेहतर बनाने और विश्लेषणात्मक डेटा एकत्र करने के लिए कुकीज़ और इसी तरह की ट्रैकिंग तकनीकों का उपयोग करती है। इनसे मिलकर बना है कुकीज़:\n• आवश्यक कुकीज़: वेबसाइट के सही ढंग से कार्य करने के लिए आवश्यक।\n• विश्लेषणात्मक कुकीज़: हमें यह समझने में मदद करती हैं कि आगंतुक साइट के साथ कैसे इंटरैक्ट करते हैं (जैसे Google Analytics)।\n• मार्केटिंग कुकीज़: प्रासंगिक सामग्री वितरित करने और अभियान की प्रभावशीलता को मापने के लिए उपयोग की जाती हैं।\n\nआप किसी भी समय आपकी ब्राउज़र सेटिंग्स के माध्यम से कुकीज़ को अक्षम कर सकते हैं; हालाँकि, कुछ साइट सुविधाएँ इच्छानुसार कार्य नहीं कर सकती हैं।`,
      },
      {
        title: "6. डेटा सुरक्षा",
        body: `हम अनधिकृत पहुंच, परिवर्तन, प्रकटीकरण या विनाश के खिलाफ आपके व्यक्तिगत डेटा की रक्षा के लिए उचित तकनीकी और संगठनात्मक उपाय लागू करते हैं। हमारी वेबसाइट सभी डेटा प्रसारणों के लिए HTTPS एन्क्रिप्शन का उपयोग करती है। इन उपायों के बावजूद, कोई भी इंटरनेट ट्रांसमिशन पूरी तरह से सुरक्षित नहीं है, और हम पूर्ण सुरक्षा की गारंटी नहीं दे सकते।`,
      },
      {
        title: "7. योर राइट्स (Your Rights)",
        body: `आपको अधिकार है:\n• आपके बारे में हमारे पास मौजूद व्यक्तिगत डेटा तक पहुँचने का.\n• गलत या अधूरी जानकारी को सही करने का अनुरोध करने का।\n• कानूनी अवधारण दायित्वों के अधीन, अपने व्यक्तिगत डेटा को हटाने का अनुरोध करने का।\n• किसी भी समय विपणन संचार के लिए सहमति वापस लेने का।\n• प्रासंगिक डेटा संरक्षण प्राधिकरण के पास शिकायत दर्ज कराने का।\n\nइनमें से किसी भी अधिकार का प्रयोग करने के लिए, software-admin@autonxt.in पर हमसे संपर्क करें या +91 9067404606 पर कॉल करें।`,
      },
      {
        title: "8. तीसरे पक्ष के लिंक",
        body: `हमारी वेबसाइट में लिंक्डइन, यूट्यूब और अन्य भागीदार प्लेटफार्मों सहित तीसरे पक्ष की वेबसाइटों के लिंक हो सकते हैं। हम इन साइटों की गोपनीयता प्रथाओं के लिए ज़िम्मेदार नहीं हैं और आपको उनकी संबंधित गोपनीयता नीतियों की समीक्षा करने के लिए प्रोत्साहित करते हैं।`,
      },
      {
        title: "9. इस नीति में परिवर्तन",
        body: `ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड किसी भी समय इस गोपनीयता नीति को अपडेट करने का अधिकार सुरक्षित रखता है। किसी भी बदलाव को एक अद्यतन प्रभावी तिथि के साथ इस पृष्ठ पर प्रकाशित किया जाएगा। हम आपको समय-समय पर इस नीति की समीक्षा करने के लिए प्रोत्साहित करते हैं।`,
      },
      {
        title: "10. संपर्क करें",
        body: `इस गोपनीयता नीति से संबंधित किसी भी प्रश्न, चिंता या अनुरोध के लिए, कृपया संपर्क करें:\n\nऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड\n704 और 705, एम्फोटेक आईटी पार्क, रोड 8, वागले एस्टेट रोड,\nपडवाल नगर, ठाणे वेस्ट, ठाणे, महाराष्ट्र 400604\nफोन: +91 9067404606\nईमेल: software-admin@autonxt.in`,
      },
    ]
  },
  termsPage: {
    metaTitle: "नियम और शर्तें | AutoNxt",
    metaDescription: "ऑटोनेक्स्ट ऑटोमेशन उपयोग के नियम और शर्तें।",
    texts: {
      legalBadge: "कानूनी",
      termsTitle: "नियम और शर्तें",
      effectiveDate: "प्रभावी तिथि: 1 जनवरी 2025 · ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड",
      termsIntro: "कृपया ऑटोनेक्स्ट वेबसाइट का उपयोग करने से पहले इन नियमों और शर्तों को ध्यान से पढ़ें। इस साइट पर आकर, आप स्वीकार करते हैं कि आपने इन शर्तों को पढ़, समझ लिया है और इनसे बंधे रहने के लिए सहमत हैं।",
      backToHome: "मुख्य पृष्ठ पर वापस जाएं",
      copyright: "© 2025 ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. सर्वाधिकार सुरक्षित।",
    },
    sections: [
      {
        title: "1. शर्तों की स्वीकृति",
        body: `ऑटोनेक्स्ट वेबसाइट (autonxt.in) और किसी भी संबद्ध सेवाओं तक पहुँचने या उनका उपयोग करके, आप इन नियमों और शर्तों से बंधे रहने के लिए सहमत हैं। यदि आप इन शर्तों से सहमत नहीं हैं, तो आपको हमारी वेबसाइट या सेवाओं का उपयोग नहीं करना चाहिए। ये शर्तें ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड के सभी आगंतुकों, उपयोगकर्ताओं और ग्राहकों पर लागू होती हैं।`,
      },
      {
        title: "2. ऑटोनेक्स्ट के बारे में",
        body: `ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड कंपनी अधिनियम, 2013 के तहत पंजीकृत एक कंपनी है, जिसका पंजीकृत कार्यालय यहां स्थित है:\n\n704 और 705, एम्फोटेक आईटी पार्क, रोड 8, वागले एस्टेट रोड,\nपडवाल नगर, ठाणे वेस्ट, ठाणे, महाराष्ट्र 400604\nCIN: [U29301MH2016PTC XXXXXX]\nGSTIN: [27XXXXX]`,
      },
      {
        title: "3. वेबसाइट का उपयोग",
        body: `आप इस वेबसाइट का उपयोग केवल वैध उद्देश्यों के लिए और इस तरह से करने के लिए सहमत हैं जिससे दूसरों के अधिकारों का उल्लंघन न हो। आपको निम्नलिखित नहीं करना चाहिए:\n• किसी भी तरह से साइट का उपयोग करना जो लागू स्थानीय, राष्ट्रीय या अंतर्राष्ट्रीय कानून या विनियमन का उल्लंघन करता हो।\n• अवांछित प्रचार सामग्री या स्पैम प्रसारित करना।\n• वेबसाइट या उसके संबंधित प्रणालियों के किसी भी हिस्से में अनधिकृत पहुंच प्राप्त करने का प्रयास करना।\n• हमारी स्पष्ट लिखित सहमति के बिना इस वेबसाइट के किसी भी हिस्से को पुनरुत्पादित करना, उसकी नकल करना, कॉपी करना या दोबारा बेचना।\n\nऑटोनेक्स्ट इन शर्तों का उल्लंघन करने वाले किसी भी उपयोगकर्ता के लिए वेबसाइट तक पहुंच को निलंबित या प्रतिबंधित करने का अधिकार सुरक्षित रखता है।`,
      },
      {
        title: "4. उत्पाद की जानकारी और मूल्य निर्धारण",
        body: `इस वेबसाइट पर दिखाए गए सभी उत्पाद विनिर्देश, प्रदर्शन के आंकड़े और मूल्य निर्धारण केवल सांकेतिक हैं और बिना किसी सूचना के परिवर्तन के अधीन हैं। ऑर्डर के समय अंतिम मूल्य निर्धारण, वितरण समय सीमा और वारंटी शर्तों की लिखित पुष्टि की जाएगी। ऑटोनेक्स्ट किसी भी समय किसी भी उत्पाद, प्रस्ताव या विनिर्देश को वापस लेने या संशोधित करने का अधिकार सुरक्षित रखता है।`,
      },
      {
        title: "5. डेमो बुकिंग और पूछताछ",
        body: `इस वेबसाइट के माध्यम से डेमो बुकिंग या उत्पाद पूछताछ सबमिट करना एक बाध्यकारी अनुबंध या खरीद आदेश का गठन नहीं करता है। सभी बुकिंग उपलब्धता और ऑटोनेक्स्ट प्रतिनिधि द्वारा पुष्टि के अधीन हैं। ऑटोनेक्स्ट अपने विवेक से किसी भी बुकिंग अनुरोध को अस्वीकार करने का अधिकार सुरक्षित रखता है।`,
      },
      {
        title: "6. बौद्धिक संपदा (Intellectual Property)",
        body: `इस वेबसाइट की सभी सामग्री — जिसमें पाठ, चित्र, ग्राफिक्स, लोगो, वीडियो और सॉफ्टवेयर शामिल हैं, लेकिन इन्हीं तक सीमित नहीं हैं — ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड या उसके लाइसेंसदाताओं की बौद्धिक संपदा है, और लागू भारतीय और अंतर्राष्ट्रीय बौद्धिक संपदा कानूनों द्वारा संरक्षित है। आप ऑटोनेक्स्ट की पूर्व लिखित अनुमति के बिना किसी भी सामग्री का उपयोग, पुनरुत्पादन या वितरण नहीं कर सकते हैं।`,
      },
      {
        title: "7. अस्वीकरण और दायित्व की सीमा",
        body: `यह वेबसाइट और इसकी सामग्री बिना किसी वारंटी के \"जैसी है वैसी ही\" प्रदान की जाती है। ऑटोनेक्स्ट यह वारंटी नहीं देता है कि वेबसाइट त्रुटि रहित, निर्बाध, या वायरस या अन्य हानिकारक घटकों से मुक्त होगी।\n\nलागू कानून द्वारा अनुमत अधिकतम सीमा तक, इस वेबसाइट या हमारी सेवाओं के आपके उपयोग से उत्पन्न होने वाले किसी भी अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी या दंडात्मक नुकसान के लिए ऑटोनेक्स्ट उत्तरदायी नहीं होगा।`,
      },
      {
        title: "8. तीसरे पक्ष के लिंक",
        body: `इस वेबसाइट में तीसरे पक्षों द्वारा संचालित बाहरी वेबसाइटों के लिंक हो सकते हैं। ये लिंक केवल सुविधा के लिए प्रदान किए गए हैं। ऑटोनेक्स्ट किसी भी संबद्ध तीसरे पक्ष की वेबसाइटों की सामग्री या प्रथाओं के लिए ज़िम्मेदार नहीं है।`,
      },
      {
        title: "9. गवर्निंग लॉ और क्षेत्राधिकार",
        body: `ये नियम और शर्तें भारत के कानूनों के अनुसार शासित और समझी जाती हैं। इन शर्तों से उत्पन्न होने वाले किसी भी विवाद को ठाणे, महाराष्ट्र में अदालतों के अनन्य क्षेत्राधिकार के अधीन किया जाएगा।`,
      },
      {
        title: "10. संशोधन",
        body: `ऑटोनेक्स्ट किसी भी समय इन नियमों और शर्तों को संशोधित करने का अधिकार सुरक्षित रखता है। अद्यतन शर्तों को संशोधित प्रभावी तिथि के साथ इस पृष्ठ पर पोस्ट किया जाएगा। किसी भी बदलाव के बाद वेबसाइट का निरंतर उपयोग संशोधित शर्तों की आपकी स्वीकृति का गठन करता है।`,
      },
      {
        title: "11. संपर्क करें",
        body: `इन नियमों और शर्तों के संबंध में किसी भी प्रश्न के लिए संपर्क करें:\n\nऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड\n704 और 705, एम्फोटेक आईटी पार्क, रोड 8, वागले एस्टेट रोड,\nपडवाल नगर, ठाणे वेस्ट, ठाणे, महाराष्ट्र 400604\nफोन: +91 9067404606\nईमेल: sales@autonxt.in`,
      },
    ]
  },
  accountDeletionPage: {
    metaTitle: "खाता और डेटा विलोपन — AUTONXT-Attendance | AutoNxt",
    texts: {
      legalBadge: "उपयोगकर्ता डेटा",
      pageTitle: "खाता और डेटा हटाना — AUTONXT-Attendance",
      pageSubtitle: "अपने AUTONXT-Attendance ऐप खाते और संबंधित व्यक्तिगत डेटा को हटाने का अनुरोध करें।",
      metaDescription:
        "AUTONXT-Attendance (com.autonxt.attendance.app2) खाता हटाएं। AutoNxt Automation Pvt. Ltd. (autonxtdeveloper) की आधिकारिक खाता हटाने की पृष्ठ।",
      effectiveDate: "प्रभावी तिथि: 18 जून 2025 · ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड",
      pageIntro:
        'ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड ("ऑटोनेक्स्ट"), AUTONXT-Attendance मोबाइल ऐप (पैकेज: com.autonxt.attendance.app2, Google Play डेवलपर: autonxtdeveloper) का डेवलपर, यह पृष्ठ उन ऐप उपयोगकर्ताओं के लिए है जो अपना खाता और संबंधित व्यक्तिगत डेटा हटाना चाहते हैं।',
      requestTitle: "AUTONXT-Attendance खाता हटाने का अनुरोध कैसे करें",
      requestButton: "हटाने का अनुरोध ईमेल करें",
      requestMailto:
        "mailto:software-admin@autonxt.in?subject=AUTONXT-Attendance%20-%20Account%20Deletion%20Request&body=Please%20delete%20my%20AUTONXT-Attendance%20app%20account%20and%20associated%20data.%0A%0AApp%3A%20AUTONXT-Attendance%20(com.autonxt.attendance.app2)%0ARegistered%20email%20/%20phone%3A%20%0AEmployee%20ID%20(if%20any)%3A%20%0AAccount%20username%20(if%20any)%3A%20%0AReason%20(optional)%3A%20",
      processingNote:
        "हम सत्यापित हटाने के अनुरोधों को आमतौर पर 30 दिनों के भीतर संसाधित करते हैं। आपके खाते और पात्र डेटा को हटाए जाने के बाद आपको पुष्टि ईमेल प्राप्त होगा।",
      deletedTitle: "हटाया जाने वाला डेटा",
      retainedTitle: "रखा जा सकने वाला डेटा",
      privacyLinkTitle: "गोपनीयता नीति",
      privacyLinkDesc: "हम डेटा कैसे एकत्र और उपयोग करते हैं, इसके लिए हमारी पूर्ण गोपनीयता नीति पढ़ें।",
      privacyLinkButton: "गोपनीयता नीति देखें",
      backToHome: "होम पर वापस जाएं",
      copyright: "© 2025 ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. सर्वाधिकार सुरक्षित।",
    },
    steps: [
      "अपने AutoNxt ऐप खाते से जुड़े ईमेल पते से software-admin@autonxt.in पर ईमेल भेजें।",
      "विषय पंक्ति का उपयोग करें: AutoNxt App - Account Deletion Request।",
      "अपना पंजीकृत ईमेल पता, फोन नंबर और खाता उपयोगकर्ता नाम (यदि लागू हो) शामिल करें ताकि हम आपकी पहचान सत्यापित कर सकें।",
      "हमारी टीम आपके अनुरोध को सत्यापित करेगी और आपके खाते के साथ संबंधित व्यक्तिगत डेटा को हटा देगी।",
      "हटाने के पूरा होने पर आपको पुष्टि ईमेल प्राप्त होगा।",
    ],
    deletedItems: [
      "आपकी ऐप खाता प्रोफ़ाइल (नाम, ईमेल, फोन नंबर और लॉगिन क्रेडेंशियल)",
      "उपयोगकर्ता प्राथमिकताएं और ऐप सेटिंग्स",
      "आपके खाते से जुड़ी सहेजी गई बुकिंग, डेमो अनुरोध और पूछताछ इतिहास",
      "ऐप सूचनाओं के लिए उपयोग किए गए पुश नोटिफिकेशन टोकन और डिवाइस पहचानकर्ता",
      "आपके खाते से जुड़ा चैट या सहायता वार्तालाप इतिहास",
      "केवल आपकी उपयोगकर्ता प्रोफ़ाइल से जुड़ा फ्लीट या ट्रैक्टर मॉनिटरिंग डेटा (जहां लागू हो)",
    ],
    retainedItems: [
      "कानूनी, कर या लेखा अनुपालन के लिए आवश्यक लेनदेन, चालान या वारंटी रिकॉर्ड (लागू कानून के अनुसार, आमतौर पर 7 वर्ष तक)",
      "अनाम या एकत्रित विश्लेषण डेटा जो आपको व्यक्तिगत रूप से पहचान नहीं सकता",
      "भारतीय कानून या वैध अदालत/नियामक आदेश के तहत रखने के लिए कानूनी रूप से आवश्यक रिकॉर्ड",
      "बैकअप प्रतियां स्थायी रूप से हटाए जाने से पहले हटाने के बाद 90 दिनों तक बनी रह सकती हैं",
    ],
    sections: [
      {
        title: "ऐप में हटाना (जहां उपलब्ध हो)",
        body: "यदि आपके AutoNxt ऐप संस्करण में इन-ऐप खाता हटाने का विकल्प है, तो आप अपना खाता यहां से भी हटा सकते हैं:\n\nऐप → प्रोफ़ाइल / सेटिंग्स → खाता → खाता हटाएं\n\nयदि यह विकल्प आपके ऐप संस्करण में दिखाई नहीं देता है, तो कृपया ऊपर वर्णित ईमेल प्रक्रिया का उपयोग करें।",
      },
      {
        title: "पहचान सत्यापन",
        body: "आपके खाते की सुरक्षा के लिए, हम हटाने के अनुरोध को संसाधित करने से पहले पंजीकृत ईमेल पते या फोन नंबर की स्वामित्व की पुष्टि करने के लिए कह सकते हैं। हम असत्यापित तृतीय-पक्ष अनुरोध के आधार पर खाता नहीं हटाएंगे।",
      },
      {
        title: "प्रसंस्करण समयरेखा",
        body: "सत्यापित खाता हटाने के अनुरोध 30 दिनों के भीतर संसाधित किए जाते हैं। इस अवधि के दौरान, आपका खाता तुरंत निष्क्रिय किया जा सकता है, लेकिन सभी बैकअप और सिस्टम से पूर्ण हटाने में 90 दिन तक लग सकते हैं।",
      },
      {
        title: "संपर्क करें",
        body: "खाता हटाने के अनुरोध या आपके व्यक्तिगत डेटा के बारे में प्रश्नों के लिए:\n\nऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड\n704 और 705, एम्फोटेक आईटी पार्क, रोड 8, वागले एस्टेट रोड,\nपडवाल नगर, ठाणे वेस्ट, ठाणे, महाराष्ट्र 400604\nफोन: +91 9067404606\nईमेल: software-admin@autonxt.in",
      },
    ],
  },
  notFoundPage: {
    title: "404 पृष्ठ नहीं मिला",
    desc: "क्या आप राउटर में पृष्ठ जोड़ना भूल गए?",
  },
  attachmentDetailPage: {
    availableNow: "अभी उपलब्ध है",
    productNotFound: "उत्पाद नहीं मिला",
    backToProducts: "उत्पादों पर वापस जाएं",
    interactiveModel: "इंटरैक्टिव मॉडल",
    preview3D: "3D पूर्वावलोकन",
    loadingModel: "3D मॉडल लोड हो रहा है...",
    specifications: "विवरण",
    technicalDetails: "तकनीकी विवरण",
    whyChoose: "यह उत्पाद क्यों चुनें",
    features: "विशेषताएं",
    quoteBtn: "कोटेशन का अनुरोध करें",
    bookBtn: "डेमो बुक करें",
    stats: {
      support: "सहायता",
      supportVal: "24/7",
      availability: "उपलब्धता",
      availabilityVal: "अखिल भारतीय",
      response: "प्रतिक्रिया",
      responseVal: "< 24 घंटे"
    },
    attachments: {
      bucket: {
        name: "18 फीट ग्रेबर बकेट",
        type: "हैवी ड्यूटी इम्प्लीमेंट",
        badge: "हैवी ड्यूटी",
        tagline: "किसी भी इलाके के लिए अधिकतम खुदाई शक्ति",
        desc: "कुशल सामग्री प्रबंधन और उत्खनन कार्यों के लिए डिज़ाइन किया गया हेवी-ड्यूटी 18 फीट ग्रैबर बकेट अटैचमेंट। मांग वाले निर्माण और कृषि वातावरण में अधिकतम स्थायित्व और प्रदर्शन के लिए प्रीमियम सामग्री और उन्नत इंजीनियरिंग के साथ निर्मित।",
        specs: {
          width: "18 फीट",
          capacity: "0.8m³",
          material: "हार्डॉक्स 450",
          weight: "480 किग्रा",
          power: "45 kW",
          battery: "50 kWh",
          runtime: "6-8 घंटे",
          charging: "4-5 घंटे",
          widthLabel: "चौड़ाई",
          capacityLabel: "क्षमता",
          materialLabel: "सामग्री",
          weightLabel: "वजन",
          powerLabel: "शक्ति",
          batteryLabel: "बैटरी",
          runtimeLabel: "रन टाइम",
          chargingLabel: "चार्जिंग"
        },
        features: [
          { title: "हार्डॉक्स स्टील", desc: "कठिन वातावरण में दीर्घकालिक स्थायित्व के लिए अत्यधिक घिसाव प्रतिरोध।" },
          { title: "यूनिवर्सल हिच", desc: "सभी ऑटोनेक्स्ट ट्रैक्टर प्लेटफॉर्म के साथ संगत।" },
          { title: "क्विक रिलीज टीथ", desc: "आसान रखरखाव के लिए बदलने योग्य दांत प्रणाली।" }
        ],
        highlights: [
          "हैवी ड्यूटी डिजाइन",
          "शून्य उत्सर्जन संगत",
          "3 पॉइंट हिच",
          "औद्योगिक ग्रेड स्टील",
          "त्वरित रखरखाव",
          "भारत के लिए निर्मित"
        ]
      },
      catcher: {
        name: "18 फीट कैचर",
        type: "सटीक इम्प्लीमेंट",
        badge: "प्रिसिजन",
        tagline: "कुशल सामग्री संग्रह और कटाई",
        desc: "कुशल सामग्री संग्रह और प्रबंधन कार्यों के लिए डिज़ाइन किया गया सटीक-इंजीनियर 18 फीट कैचर अटैचमेंट। कृषि और औद्योगिक अनुप्रयोगों में इष्टतम प्रदर्शन के लिए उन्नत हाइड्रोलिक नियंत्रण और टिकाऊ निर्माण की विशेषता। उन्नत सटीकता और विश्वसनीयता के साथ कटाई, सामग्री छंटनी और विशिष्ट संग्रह कार्यों के लिए आदर्श। मांग वाले वातावरण में निरंतर प्रदर्शन देने के लिए प्रीमियम सामग्री और अत्याधुनिक इंजीनियरिंग के साथ निर्मित।",
        specs: {
          width: "18 फीट",
          capacity: "0.75m³",
          material: "हार्डॉक्स 400",
          weight: "450 किग्रा",
          power: "40 kW",
          battery: "45 kWh",
          runtime: "5–7 घंटे",
          charging: "3–4 घंटे",
          widthLabel: "चौड़ाई",
          capacityLabel: "क्षमता",
          materialLabel: "सामग्री",
          weightLabel: "वजन",
          powerLabel: "शक्ति",
          batteryLabel: "बैटरी",
          runtimeLabel: "रन टाइम",
          chargingLabel: "चार्जिंग"
        },
        features: [
          { title: "सटीक इंजीनियरिंग", desc: "सटीक सामग्री संग्रह और न्यूनतम रिसाव के लिए अनुकूलित डिजाइन।" },
          { title: "यूनिवर्सल हिच", desc: "सभी ऑटोनेक्स्ट ट्रैक्टर प्लेटफॉर्म के साथ संगत।" },
          { title: "आसान रखरखाव", desc: "त्वरित सर्विसिंग के लिए सरल रखरखाव डिजाइन।" }
        ],
        highlights: [
          "सटीक डिजाइन",
          "शून्य उत्सर्जन संगत",
          "3 पॉइंट हिच",
          "अनुकूलित क्षमता",
          "आसान रखरखाव",
          "भारत के लिए निर्मित"
        ]
      },
      loader: {
        name: "18 फीट लोडर बकेट",
        type: "मैक्स लोड इम्प्लीमेंट",
        badge: "अधिकतम लोड",
        tagline: "लोडिंग और सामग्री परिवहन में अधिकतम दक्षता",
        desc: "लोडिंग और सामग्री परिवहन कार्यों में अधिकतम दक्षता के लिए इंजीनियर किया गया हेवी-ड्यूटी 18 फीट लोडर बकेट। सबसे कठिन निर्माण, खनन और कृषि कार्यों को संभालने के लिए बेहतर ताकत वाली सामग्री और उन्नत हाइड्रोलिक सिस्टम के साथ निर्मित। बेहतर सामग्री अवधारण और कुशल लोडिंग चक्र के लिए अनुकूलित बकेट ज्यामिति की विशेषता। चरम कामकाजी परिस्थितियों का सामना करने के लिए डिज़ाइन किया गया है जबकि चरम प्रदर्शन और परिचालन विश्वसनीयता बनाए रखता है।",
        specs: {
          width: "18 फीट",
          capacity: "0.9m³",
          material: "हार्डॉक्स 500",
          weight: "520 किग्रा",
          power: "50 kW",
          battery: "55 kWh",
          runtime: "7–9 घंटे",
          charging: "4–6 घंटे",
          widthLabel: "चौड़ाई",
          capacityLabel: "क्षमता",
          materialLabel: "सामग्री",
          weightLabel: "वजन",
          powerLabel: "शक्ति",
          batteryLabel: "बैटरी",
          runtimeLabel: "रन टाइम",
          chargingLabel: "चार्जिंग"
        },
        features: [
          { title: "अधिकतम क्षमता", desc: "भारी संचालन में अधिकतम भार क्षमता और स्थायित्व के लिए इंजीनियर किया गया।" },
          { title: "यूनिवर्सल हिच", desc: "सभी ऑटोनेक्स्ट ट्रैक्टर प्लेटफॉर्म के साथ संगत।" },
          { title: "मजबूत संरचना", desc: "अधिकतम भार को सुरक्षित रूप से संभालने के लिए अतिरिक्त सुदृढीकरण।" }
        ],
        highlights: [
          "अधिकतम क्षमता",
          "शून्य उत्सर्जन संगत",
          "3 पॉइंट हिच",
          "प्रबलित स्टील",
          "हैवी ड्यूटी डिजाइन",
          "भारत के लिए निर्मित"
        ]
      }
    }
  },
  aboutPage: {
    aboutAutoNxt: "ऑटोनेक्स्ट के बारे में",
    foundedLabel: "स्थापित",
    headquarteredLabel: "मुख्यालय",
    teamSizeLabel: "टीम का आकार",
    foundedInMumbai: "मुंबई में स्थापित",
    connectLinkedIn: "लिंक्डइन पर जुड़ें",
    ourJourney: "हमारी यात्रा",
    fromConcept: "अवधारणा से बाजार के अगुआ तक।",
    team: [
      { name: "कौस्तुभ धोंडे", role: "मुख्य कार्यकारी अधिकारी", bio: "अभिनव इलेक्ट्रिक वाहन समाधानों के साथ कृषि में क्रांति लाने के ऑटोनेक्स्ट के मिशन को आगे बढ़ाने वाले दूरदर्शी नेता।" },
      { name: "पंकज गोयल", role: "सह-संस्थापक और सीओओ", bio: "परिचालन रणनीतिकार जो सुचारू निष्पादन और विकास सुनिश्चित करते हैं, दैनिक संचालन और साझेदारियों की देखरेख करते हैं।" },
      { name: "गौरव बोरकर", role: "चीफ फाइनेंशियल ऑफिसर", bio: "वित्तीय रणनीति, फंड जुटाने और कॉर्पोरेट गवर्नेंस का नेतृत्व करने वाले अनुभवी वित्त विशेषज्ञ।" },
      { name: "अमित कुमार शिवहरे", role: "हेड – अकाउंट्स एंड फाइनेंस (Head – Accounts & Finance)", bio: "ईवी विनिर्माण, प्रौद्योगिकी और बुनियादी ढांचे में वित्तीय रणनीति, शासन और व्यावसायिक प्रदर्शन का नेतृत्व करने वाले वरिष्ठ वित्त लीडर।" },
      { name: "हरि किशन", role: "प्लांट हेड", bio: "संयंत्र संचालन की देखरेख करते हैं, उत्पादित प्रत्येक ट्रैक्टर में गुणवत्ता और दक्षता सुनिश्चित करते हैं।" },
      { name: "सुदीप्तो देब", role: "लीड पावर ट्रेन इंजीनियर", bio: "पावर इलेक्ट्रॉनिक्स के विशेषज्ञ, हमारे ट्रैक्टरों को ऊर्जा देने वाली विद्युत प्रणालियों के डिजाइन और अनुकूलन के लिए जिम्मेदार।" },
      { name: "वमसी अतूरी", role: "लीड मैकेनिकल डिजाइन इंजीनियर", bio: "यांत्रिक डिजाइन अन्वेषक, विभिन्न कृषि आवश्यकताओं के लिए मजबूत और कुशल ट्रैक्टर संरचनाओं का निर्माण करते हैं।" },
      { name: "डॉ. धर्मतेजा अडापा", role: "लीड रोबोटिक्स इंजीनियर", bio: "स्वचालन विशेषज्ञ जो सहज और विश्वसनीय ट्रैक्टर प्रदर्शन के लिए स्मार्ट तकनीकों को एकीकृत करने पर ध्यान केंद्रित करते हैं।" },
      { name: "तेजेश मदीरेड्डी", role: "लीड एंबेडेड इंजीनियर", bio: "एंबेडेड सिस्टम विकास का नेतृत्व करते हैं, विश्वसनीय और कुशल हार्डवेयर-सॉफ्टवेयर एकीकरण सुनिश्चित करते हैं।" },
      { name: "अश्वंत मुलुपुरी", role: "रोबोटिक्स और ऑटोमेशन इंजीनियर", bio: "स्वचालन में विशेषज्ञ, स्वायत्त ट्रैक्टर संचालन के लिए उन्नत नियंत्रण प्रणालियों का विकास करते हैं।" },
      { name: "अजिंक्य दलवी", role: "Power Train Engineer", bio: "पावर ट्रेन सिस्टम पर काम करते हैं, प्रदर्शन और दक्षता का अनुकूलन करते हैं।" },
      { name: "खुशप्रीत सिंह", role: "परीक्षण और सत्यापन इंजीनियर", bio: "कठिन परीक्षण और सत्यापन के लिए जिम्मेदार, हमारे उत्पादों की विश्वसनीयता और सुरक्षा की गारंटी देते हैं।" },
      { name: "स्वपनेश जहागीरदार", role: "व्यवसाय विकास प्रबंधक", bio: "कंपनी के विस्तार में तेजी लाने के लिए नए अवसरों की पहचान करने और संबंधों को बढ़ावा देने पर केंद्रित।" }
    ],
    advisors: [
      { name: "आईवी-राव", role: "वरिष्ठ सलाहकार", bio: "एक साथ मिलकर, हम सार्थक डिजाइन और स्थायी प्रासंगिकता के माध्यम से बेहतर भविष्य के लिए खुद को चुनौती देते हैं।" },
      { name: "आशीष मेहता", role: "वित्तीय सलाहकार", bio: "समकालीन डिजाइन और अच्छी तरह से निर्मित उत्पाद ऐसी चीजें हैं जिनसे हर किसी को लाभ होना चाहिए — यही हमारे कार्यों को प्रेरित करता है।" },
      { name: "स्वदीप पिल्लारीशेट्टी", role: "रणनीति सलाहकार", bio: "हमारा संग्रह निरंतर विकसित होने वाला लेकिन हमेशा प्रासंगिक है। हमारा उद्देश्य आपको अपनी पसंद का रूप प्रदर्शित करने के लिए प्रेरित करना और मदद करना है।" }
    ],
    journey: [
      { year: "2016", title: "स्थापना", desc: "ऑटोनेक्स्ट ऑटोमेशन प्रा. लिमिटेड की स्थापना मुंबई में कौस्तुभ धोंडे द्वारा की गई थी, जिसका उद्देश्य इलेक्ट्रिक और स्वायत्त ट्रैक्टरों के माध्यम से कृषि और औद्योगिक कार्यों में क्रांति लाना था।" },
      { year: "2018–19", title: "अनुसंधान और प्रारंभिक प्रोटोटाइप", desc: "उच्च-टॉर्क इलेक्ट्रिक पावरट्रेन और इंटेलिजेंट控制 सिस्टम पर व्यापक आरएंडडी। ऑटोनेक्स्ट ने डीजल को इलेक्ट्रिक तकनीक से बदलने की व्यवहार्यता को साबित करते हुए शुरुआती प्रोटोटाइप का सफलतापूर्वक निर्माण और परीक्षण किया।" },
      { year: "2020–21", title: "नवाचार और विकास", desc: "होशियार वाहन नियंत्रण इकाइयों और आईओटी-आधारित निगरानी के साथ उन्नत प्रोटोटाइप। इंजीनियरिंग टीम का विस्तार किया और घटक विकास और परीक्षण के लिए साझेदारियों को मजबूत किया।" },
      { year: "2022–23", title: "सत्यापन और प्रमाणन", desc: "इलेक्ट्रिक ट्रैक्टरों का कड़ा प्रदर्शन और सुरक्षा परीक्षण किया गया। आईसीएटी (इंटरनेशनल सेंटर फॉर ऑटोमोटिव टेक्नोलॉजी) से प्रमाणपत्र प्राप्त किया, जिसके तहत 20 एचपी, 35 एचपी और 45 एचपी वेरिएंट को अंतिम रूप दिया गया।" },
      { year: "2024", title: "व्यावसायिक शुरुआत", desc: "ऑटोनेक्स्ट ने आधिकारिक तौर पर ठाणे, महाराष्ट्र में X45H2 लॉन्च किया। पहली इकाई जयवंत शुगर्स लिमिटेड को दी गई — जिसने भारत के कृषि-ईवी पारिस्थितिकी तंत्र में ऑटोनेक्स्ट को अगुआ के रूप में स्थापित किया।" },
      { year: "2025+", title: "विकास और विस्तार", desc: "कृषि और औद्योगिक क्षेत्रों में उत्पादन क्षमताओं और ग्राहक आधार का विस्तार करना। स्वायत्त ड्राइविंग, स्मार्ट कनेक्टिविटी और अगली पीढ़ी की बैटरी प्रणालियों को उन्नत करना।" }
    ],
    process: [
      { step: "01", title: "परिभाषित करें", desc: "इलेक्ट्रिक सेल्फ-ड्राइविंग ट्रैक्टरों की आवश्यकताओं को परिभाषित करना — क्षेत्र की अंतर्दृष्टि और इंजीनियरिंग सीमाओं को इकट्ठा करना।" },
      { step: "02", title: "डिजाइन", desc: "3D मॉडल और योजनाबद्ध आरेख बनाना, मोटर, बैटरी और सेंसर जैसे घटकों का चयन करना और स्वायत्त ड्राइविंग सिस्टम को डिजाइन करना।" },
      { step: "03", title: "विकास", desc: "चेसिस, मोटर, बैटरी, सेंसर और स्वायत्त ड्राइविंग सिस्टम सहित भौतिक घटकों का निर्माण करना।" },
      { step: "04", title: "परीक्षण", desc: "भारत के विभिन्न इलाकों, मौसम की स्थिति और ड्राइविंग परिदृश्यों में प्रदर्शन का परीक्षण करना।" },
      { step: "05", title: "सुधार", desc: "परीक्षण परिणामों के आधार पर, घटकों को समायोजित करना, सॉफ्टवेयर एल्गोरिदम को ठीक करना, या उपयोगकर्ता इंटरफ़ेस में बदलाव करना।" },
      { step: "06", title: "उत्पादन", desc: "विनिर्माण प्रक्रिया स्थापित करना, घटकों को सोर्स करना और बड़े पैमाने पर वितरण नेटवर्क विकसित करना।" }
    ],
    values: [
      { title: "ग्राहक सर्वोपरि", desc: "हम अपने ग्राहकों की आवश्यकताओं और संतुष्टि को सबसे ऊपर प्राथमिकता देते हैं।" },
      { title: "नवाचार", desc: "इलेक्ट्रिक वाहन तकनीक में सीमाओं को लगातार आगे बढ़ाना।" },
      { title: "उत्कृष्टता", desc: "उच्चतम गुणवत्ता वाले उत्पादों और सेवाओं को प्रदान करने के लिए प्रतिबद्ध।" },
      { title: "सस्टेनेबिलिटी", desc: "कृषि के लिए एक हरित भविष्य के निर्माण के लिए समर्पित।" }
    ]
  },
  galleryPage: {
    galleryPhotos: "तस्वीरें",
    galleryVideos: "वीडियो",
    galleryEvents: "आयोजन",
    eventHandoverTitle: "आधिकारिक सरकारी हैंडओवर समारोह",
    eventHandoverDesc: "29 जून, 2025 — ऑटोनेक्स्ट ने सरकारी अधिकारियों, पुलिस प्रतिनिधियों और मीडिया की उपस्थिति में एक आधिकारिक समारोह में X45H2 इलेक्ट्रिक ट्रैक्टर वितरित किया। भारत के सार्वजनिक संस्थानों की सेवा करने की ऑटोनेक्स्ट की यात्रा में एक ऐतिहासिक क्षण।",
    photos: [
      { alt: "व्यावसायिक प्रेषण (डिस्पैच) के लिए तैयार ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टरों की पहली खेप", label: "पहली खेप का प्रेषण", tag: "फील्ड में" },
      { alt: "वितरण (डिलीवरी) के लिए परिवहन ट्रक पर लोड किए गए ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर", label: "वितरण के लिए लोड किए गए ट्रैक्टर", tag: "फील्ड में" },
      { alt: "परिवहन के लिए तैयार ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टरों की खेप", label: "परिवहन में खेप", tag: "फील्ड में" },
      { alt: "नासिक में कृषितॉन 2023 प्रदर्शनी में प्रदर्शित ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर", label: "कृषितॉन 2023 — नासिक शोकेस", tag: "फील्ड में" },
      { alt: "कृषितॉन 2023 में ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर लोडर का प्रदर्शन", label: "कृषितॉन 2023 — लोडर प्रदर्शन", tag: "फील्ड में" },
      { alt: "कमर्शियल ट्रेलर के साथ ऑटोनेक्स्ट X45H2", label: "X45H2 — व्यावसायिक ढुलाई", tag: "औद्योगिक" }
    ],
    events: [
      { alt: "अधिकारियों और मीडिया के साथ ऑटोनेक्स्ट X45H2 लॉन्च समारोह", label: "आधिकारिक लॉन्च संबोधन — 29 जून, 2025", tag: "आयोजन" },
      { alt: "एमओयू हस्ताक्षर समारोह — ऑटोनेक्स्ट ट्रैक्टर हैंडओवर", label: "हैंडओवर समारोह और समझौता ज्ञापन पर हस्ताक्षर", tag: "आयोजन" },
      { alt: "अधिकारी ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रैक्टर को आशीर्वाद देते हुए", label: "X45H2 उद्घाटन समारोह", tag: "आयोजन" },
      { alt: "ऑटोनेक्स्ट X45H2 के आसपास एकत्र गणमान्य व्यक्ति और टीम", label: "X45H2 — आधिकारिक आशीर्वाद", tag: "आयोजन" },
      { alt: "समारोह के दौरान मेहमानों से घिरा ऑटोनेक्स्ट X45H2 ट्रैक्टर", label: "X45H2 — फ्लैग-ऑफ समारोह", tag: "आयोजन" },
      { alt: "तिरंगे गुब्बारे का मेहराब और कार्यक्रम में X45H2 का प्रदर्शन", label: "तिरंगा लॉन्च स्टेज — 29 जून, 2025", tag: "आयोजन" },
      { alt: "लॉन्च इवेंट में ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रैक्टर का क्लोज-अप", label: "ऑटोनेक्स्ट X45H2 — करीब से", tag: "उत्पाद" }
    ],
    videos: [
      { title: "ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रैक्टर — उत्पाद विवरण (अंग्रेजी में)", desc: "ऑटोनेक्स्ट के फ्लैगशिप 45HP इलेक्ट्रिक ट्रैक्टर का पूरा विवरण — X45H2 — जिसमें विनिर्देश, विशेषताएं और क्षमताएं शामिल हैं।" },
      { title: "X45H2 — भारी बारिश और बाढ़ वाले खेतों में रोटावेटर पडलिंग", desc: "भारी बारिश के मौसम और पूरी तरह से बाढ़ वाले खेतों में X45H2 को रोटावेटर पडलिंग संचालन करते हुए देखें।" },
      { title: "महाराष्ट्र का पहला इलेक्ट्रिक ट्रैक्टर जयवंत शुगर मिल को दिया गया", desc: "जयवंत शुगर मिल, कराड, सतारा को पहले ऑटोनेक्स्ट इलेक्ट्रिक ट्रैक्टर की ऐतिहासिक डिलीवरी — भारतीय कृषि-ईवी के लिए एक मील का पत्थर।" },
      { title: "ऑटोनेक्स्ट 45HP इलेक्ट्रिक ट्रैक्टर — फुल पावर डेमो", desc: "विभिन्न कृषि कार्यों में X45H2 को अपनी पूरी टॉर्क और प्रदर्शन क्षमताओं का प्रदर्शन करते हुए देखें।" },
      { title: "X45H2 — ढुलाई, टिलर, रीपर और वाटर जेट वॉश", desc: "ढुलाई, जुताई, कटाई और पूरी तरह से वाटर जेट वॉश करने वाले X45H2 का व्यापक क्षेत्र प्रदर्शन।" },
      { title: "ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रैक्टर — उत्पाद विवरण (हिंदी में)", desc: "हिंदी में ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रैक्टर का पूरा उत्पाद विवरण — भारतीय किसानों के लिए।" }
    ]
  },
  blogPage: {
    postsLabel: "लेख",
    postsValue: "20+",
    authorsLabel: "लेखक",
    authorsValue: "6",
    topicsLabel: "विषय",
    posts: [
      {
        tag: "तकनीक",
        title: "भारतीय कृषि में क्रांति: ऑटोनेक्स्ट के इलेक्ट्रिक ट्रैक्टर किसानों के लिए बुद्धिमत्ता, स्थिरता और लाभप्रदता ला रहे हैं",
        author: "द इंडिया वायर नेटवर्क",
        date: "अगस्त 2025",
        readTime: "4 मिनट पढ़ें",
        image: "/images/x45h2Image2.webp",
        summary: "ऑटोनेक्स्ट ऑटोमेशन के संस्थापक और सीईओ कौस्तभ धोंडे और सह-संस्थापक और सीओओ पंकज गोयल के साथ एक विशेष साक्षात्कार में जानें कि कैसे उनकी कंपनी भारत में इलेक्ट्रिक ट्रैक्टर क्रांति का नेतृत्व कर रही है — किसानों की डीजल पर निर्भरता कम करने से लेकर स्मार्ट संचालन के लिए AI, IoT और टेलीमैटिक्स को एकीकृत करने तक।",
        externalUrl: "https://theindiawire.com/india/revolutionizing-indian-agriculture-autonxts-electric-tractors-bring-intelligence-sustainability-and-profitability-to-farmers/",
        featured: true
      },
      {
        tag: "स्वायत्त तकनीक",
        title: "भारत का पहला सेल्फ-ड्राइविंग ट्रैक्टर बनाना",
        author: "इनसाइडर्स टॉक",
        date: "दिसंबर 2024",
        readTime: "6 मिनट पढ़ें",
        image: "/images/videos/driverless-tractor-thumbnail.webp",
        summary: "ऑटोनेक्स्ट स्वायत्त खेती तकनीक विकसित करने में सबसे आगे है, जिसने भारत का पहला सेल्फ-ड्राइविंग ट्रैक्टर बनाया है। यह विकास किसानों को बढ़ी हुई दक्षता, कम श्रम लागत और खेती के संचालन में बेहतर सटीकता प्रदान करता है।",
        externalUrl: "https://insiderstalk.in/building-indias-first-ever-self-driving-tractor/",
        featured: false
      },
      {
        tag: "भविष्य की तकनीक",
        title: "खेती का भविष्य: भारत का पहला सेल्फ-ड्राइविंग ट्रैक्टर",
        author: "ट्रैक्टर जंक्शन",
        date: "नवंबर 2024",
        readTime: "8 मिनट पढ़ें",
        image: "/images/blog/future-of-farming.webp",
        summary: "ऑटोनेक्स्ट ऑटोमेशन भारत के पहले स्वायत्त इलेक्ट्रिक ट्रैक्टर के साथ खेती के भविष्य का नेतृत्व कर रहा है, जो टिकाऊ कृषि के साथ अत्याधुनिक तकनीक का संयोजन कर रहा है।",
        externalUrl: "https://www.tractorjunction.com/tractor-news/future-of-farming-india-first-self-driving-tractor/",
        featured: false
      },
      {
        tag: "कृषि तकनीक",
        title: "ऑटोनेक्स्ट ट्रैक्टर: इलेक्ट्रिक और स्वायत्त तकनीक के साथ कृषि में क्रांति",
        author: "ट्रैक्टर गुरु",
        date: "अक्टूबर 2024",
        readTime: "9 मिनट पढ़ें",
        image: "/images/blog/autonxt-tractor-revolutionizing-agriculture.webp",
        summary: "ऑटोनेक्स्ट के अभिनव ट्रैक्टर समाधानों का व्यापक कवरेज — इलेक्ट्रिक ट्रैक्टर, स्वायत्त ड्राइविंग क्षमताएं और स्मार्ट खेती समाधान जो भारत और उसके बाहर आधुनिक कृषि की उभरती जरूरतों को पूरा करते हैं।",
        externalUrl: "https://tractorguru.in/blog/category/autonxt-tractor/",
        featured: false
      },
      {
        tag: "कंपनी प्रोफाइल",
        title: "ऑटोनेक्स्ट ऑटोमेशन: इलेक्ट्रिक और स्वायत्त कृषि समाधानों का नेतृत्व",
        author: "ट्रैक्सन रिसर्च टीम",
        date: "सितंबर 2024",
        readTime: "7 मिनट पढ़ें",
        image: "/images/blog/game-changing-electric-tractor.webp",
        summary: "ऑटोनेक्स्ट ऑटोमेशन के अभिनव दृष्टिकोण का विस्तृत कंपनी प्रोफाइल और विश्लेषण। ऑटोनेक्स्ट ने खुद को कृषि नवाचार में एक नेता के रूप में स्थापित किया है, जो अत्याधुनिक तकनीक के साथ पर्यावरणीय स्थिरता को जोड़ता है।",
        externalUrl: "https://tracxn.com/d/companies/autonxt-automation/__ZSsZ4cr50wm63YgF4zOMI1CcYVW2V43yS-5Lojtdze0",
        featured: false
      },
      {
        tag: "कंपनी प्रोफाइल",
        title: "कौस्तुभ धोंडे: ऑटोनेक्स्ट ऑटोमेशन की कहानी, इलेक्ट्रिक और स्वायत्त कृषि समाधानों का नेतृत्व",
        author: "शुगरमिंट",
        date: "मई 2024",
        readTime: "5 मिनट पढ़ें",
        image: "/images/blog/kaustubh-dhonde-story.webp",
        summary: "ऑटोनेक्स्ट ऑटोमेशन के संस्थापक और सीईओ कौस्तुभ धोंडे के साथ एक प्रेरणादायक साक्षात्कार, जिसमें उन्होंने अपनी व्यक्तिगत प्रेरणाओं, भारत में एक ईवी ब्रांड शुरू करने की चुनौतियों और देश के पहले स्वायत्त इलेक्ट्रिक ट्रैक्टर के विकास को साझा किया।",
        externalUrl: "https://sugermint.com/kaustubh-dhonde/",
        featured: false
      },
      {
        tag: "उद्योग समाचार",
        title: "ऑटोनेक्स्ट ऑटोमेशन एक इलेक्ट्रिक - सेल्फ ड्राइविंग ट्रैक्टर लॉन्च करने के लिए तैयार",
        author: "BW ऑनलाइन ब्यूरो",
        date: "अगस्त 2022",
        readTime: "3 मिनट पढ़ें",
        image: "/images/blog/autonxt-bw-autoworld.webp",
        summary: "इलेक्ट्रिक ट्रैक्टर स्टार्टअप ऑटोनेक्स्ट ऑटोमेशन बाजार में अपने 20HP, 35HP और 45HP इलेक्ट्रिक ट्रैक्टर वेरिएंट लॉन्च करने के लिए तैयार है, जिसमें उत्पादन के लिए तैयार हाई-टॉर्क इलेक्ट्रिक पावरट्रेन और स्वायत्त ड्राइविंग सुविधाएं शामिल हैं।",
        externalUrl: "https://bwautoworld.com/article/autonxt-automation-to-launch-an-electric-self-driving-tractor-442543",
        featured: false
      }
    ]
  },
  evBlogPage: {
    articlesLabel: "लेख",
    articlesValue: "7 तकनीकी गाइड",
    topicsLabel: "मुख्य फोकस",
    topicsValue: "5 श्रेणियां",
    avgReadLabel: "औसत पठन",
    avgReadValue: "6 मिनट",
    categories: ["All", "Battery Tech", "Policy & Incentives", "Market Trends", "Future Tech"],
    articles: [
      {
        cat: "स्थिरता",
        title: "हरित विकास के लिए भारत के प्रयास में पर्यावरण के अनुकूल ट्रैक्टरों का उदय",
        date: "जनवरी 2025",
        readTime: "6 मिनट",
        image: "/images/blog/future-of-farming.webp",
        summary: "पर्यावरण के अनुकूल इलेक्ट्रिक ट्रैक्टरों के उद्भव के साथ भारत अपने कृषि क्षेत्र में एक महत्वपूर्ण परिवर्तन देख रहा है, जो देश की महत्वाकांक्षी हरित विकास पहलों और सतत विकास और कार्बन तटस्थता के प्रति अपनी प्रतिबद्धता के साथ जुड़ रहा है।",
        externalUrl: "https://www.theautomonitor.com/the-rise-of-eco-friendly-tractors-in-indias-push-for-green-growth/",
        featured: true
      },
      {
        cat: "नवाचार",
        title: "इलेक्ट्रिक ट्रैक्टर तकनीक के साथ स्थिरता और उत्पादकता को जोड़ना",
        date: "नवंबर 2025",
        readTime: "7 मिनट",
        image: "/images/blog/bridging-sustainability.webp",
        summary: "इलेक्ट्रिक ट्रैक्टर तकनीक बढ़ी हुई उत्पादकता के साथ पर्यावरणीय स्थिरता को जोड़कर कृषि में क्रांति ला रही है, किसानों को अधिक कुशल और लाभदायक कृषि संचालन के लिए एक व्यवहार्य मार्ग प्रदान कर रही है — यह साबित करते हुए कि पर्यावरणीय जिम्मेदारी और परिचालन दक्षता साथ-साथ चल सकती है।",
        externalUrl: "https://emobilityplus.com/2025/11/17/opinion-bridging-sustainability-and-productivity-with-electric-tractor-technology/",
        featured: true
      },
      {
        cat: "क्रांति",
        title: "इलेक्ट्रिक ट्रैक्टर भारतीय कृषि में सतत क्रांति को कैसे शक्ति प्रदान कर रहे हैं",
        date: "जनवरी 2025",
        readTime: "5 मिनट",
        image: "/images/blog/sustainable-revolution.webp",
        summary: "इलेक्ट्रिक ट्रैक्टर पूरे भारत में एक सतत कृषि क्रांति को चला रहे हैं, किसानों को पारंपरिक डीजल-संचालित मशीनरी के लिए स्वच्छ, कुशल और लागत प्रभावी विकल्पों के साथ सशक्त बना रहे हैं और पर्यावरण और आर्थिक दोनों चुनौतियों का समाधान कर रहे हैं।",
        externalUrl: "https://republicnewsindia.com/how-electric-tractors-are-powering-a-sustainable-revolution-in-indian-agriculture/",
        featured: false
      },
      {
        cat: "भविष्य की तकनीक",
        title: "धुएं के बिना खेती: इलेक्ट्रिक ट्रैक्टर भारतीय कृषि का भविष्य क्यों हैं",
        date: "फरवरी 2025",
        readTime: "8 मिनट",
        image: "/images/blog/farming-without-fumes.webp",
        summary: "इलेक्ट्रिक ट्रैक्टर भारतीय कृषि के भविष्य का प्रतिनिधित्व करते हैं, हानिकारक उत्सर्जन को समाप्त करते हुए बेहतर प्रदर्शन प्रदान करते हैं और देश भर में किसानों के लिए परिचालन लागत को कम करते हैं — कृषक समुदाय के लिए आगे का एक स्वच्छ, कुशल मार्ग।",
        externalUrl: "https://www.thehindubusinessline.com/economy/agri-business/farming-without-fumes-why-electric-tractors-are-the-future-of-indian-agriculture/article70202273.ece",
        featured: false
      },
      {
        cat: "बैटरी तकनीक",
        title: "इलेक्ट्रिक ट्रैक्टरों की अगली पीढ़ी को शक्ति प्रदान करने वाली अभिनव बैटरी तकनीकें",
        date: "जुलाई 2024",
        readTime: "6 मिनट",
        image: "/images/blog/innovative-battery-tech.webp",
        summary: "खोज करता है कि कैसे इलेक्ट्रिक ट्रैक्टर टिकाऊ कृषि में एक महत्वपूर्ण समाधान के रूप में उभर रहे हैं, जो अभिनव बैटरी तकनीकों, मॉड्यूलर प्रणालियों और हाइड्रोजन ईंधन कोशिकाओं द्वारा संचालित हैं।",
        externalUrl: "https://www.theautomonitor.com/innovative-battery-technologies-powering-the-next-generation-of-electric-tractors/",
        featured: false
      },
      {
        cat: "नीति और प्रोत्साहन",
        title: "सरकारी नीतियां और सब्सिडी इलेक्ट्रिक ट्रैक्टरों को अपनाने को बढ़ावा दे रही हैं",
        date: "जनवरी 2025",
        readTime: "6 मिनट",
        image: "/images/blog/government-policies.webp",
        summary: "चर्चा करता है कि कैसे सहायक सरकारी नीतियां, सब्सिडी और वैश्विक स्थिरता पहल कृषि क्षेत्र को पर्यावरण के अनुकूल इलेक्ट्रिक ट्रैक्टरों की ओर ले जा रही हैं।",
        externalUrl: "https://www.theautomonitor.com/government-policies-and-subsidies-driving-the-adoption-of-electric-tractors/",
        featured: false
      },
      {
        cat: "बाजार के रुझान",
        title: "क्यों 2026 भारतीय कृषि में इलेक्ट्रिक ट्रैक्टरों के लिए टर्निंग पॉइंट हो सकता है",
        date: "जनवरी 2026",
        readTime: "4 मिनट",
        image: "/images/blog/why-2026-turning-point.webp",
        summary: "दर्शाता है कि कैसे आगामी नीतिगत बदलाव, बैटरी लागत में कमी और तकनीकी सुधार 2026 को भारत में इलेक्ट्रिक ट्रैक्टर अपनाने के लिए एक मील का पत्थर बना सकते हैं।",
        externalUrl: "https://www.theautomonitor.com/why-2026-could-be-the-turning-point-for-electric-tractors-in-indian-agriculture/",
        featured: false
      }
    ],
    authorRoleLabel: "Publication",
    stats: [
      { value: "38%", label: "बाज़ार CAGR 2024–27" },
      { value: "₹4,000 करोड़", label: "2027 तक भारत EV ट्रैक्टर TAM" },
      { value: "70%", label: "डीजल की तुलना में कम परिचालन लागत" },
      { value: "0", label: "प्रत्यक्ष CO₂ उत्सर्जन" }
    ]
  },
  newsPage: {
    storiesLabel: "कहानियां",
    storiesValue: "50+",
    coverageLabel: "प्रकाशक",
    coverageValue: "National",
    milestonesLabel: "श्रेणियां",
    milestonesValue: "6 Key",
    readMore: "Read More",
    news: [
      {
        date: "6/18/2026",
        tag: "पुरस्कार",
        title: "ऑटोनेक्स्ट ऑटोमेशन ने ITOTY 2026 में पहला 'इलेक्ट्रिक ट्रैक्टर ऑफ द ईयर' पुरस्कार जीता",
        summary: "ऑटोनेक्स्ट ऑटोमेशन ने इंडियन ट्रैक्टर ऑफ द ईयर (ITOTY) अवार्ड्स 2026 में पहला 'इलेक्ट्रिक ट्रैक्टर ऑफ द ईयर' पुरस्कार जीता है, जो भारत के इलेक्ट्रिक कृषि मशीनरी उद्योग के लिए एक ऐतिहासिक मील का पत्थर है।",
        author: "ऑटोनेक्स्ट टीम",
        readTime: "3 मिनट पढ़ें",
        image: "/images/linkedin/linkedin-post-1.webp",
        externalUrl: "https://www.linkedin.com/posts/autonxt-automation_autonxt-itoty2026-electrictractoroftheyear-activity-7473003691902451712-w4BZ?utm_source=share&utm_medium=member_desktop&rcm=ACoAACrujPEBnx6l4DUGYojLDsLzMTTIYS7FTxk"
      },
      {
        date: "11/10/2024",
        tag: "आयोजन",
        title: "ऑटोनेक्स्ट ने दिल्ली ईवी रैली 'BREATHE' में इलेक्ट्रिक ट्रैक्टर का प्रदर्शन किया, मंत्री मनोहर लाल खट्टर ने की सराहना",
        summary: "ऑटोनेक्स्ट दिल्ली में CESL की प्रतिष्ठित EV रैली, BREATHE में शामिल होने वाला एकमात्र इलेक्ट्रिक ट्रैक्टर था। माननीय विद्युत मंत्री श्री मनोहर लाल खट्टर जी ने हमारे ट्रैक्टर की सवारी की और इसके सुचारू प्रदर्शन की सराहना की।",
        author: "ऑटोनेक्स्ट टीम",
        readTime: "3 मिनट पढ़ें",
        image: "/images/events/event-1.webp",
        externalUrl: "https://www.linkedin.com/company/autonxt-automation"
      },
      {
        date: "4/10/2024",
        tag: "उत्पाद लॉन्च",
        title: "ऑटोनेक्स्ट ऑटोमेशन भारत का पहला सेल्फ-ड्राइविंग इलेक्ट्रिक ट्रैक्टर लॉन्च करने के लिए तैयार",
        summary: "ऑटोनेक्स्ट ने भारत के पहले सेल्फ-ड्राइविंग इलेक्ट्रिक ट्रैक्टर का अनावरण किया, जो अभिनव प्रौद्योगिकी और फंडिंग समर्थन के साथ टिकाऊ खेती और वाणिज्यिक क्षेत्रों को आगे बढ़ा रहा है।",
        author: "रॉबिन कुमार अत्री",
        readTime: "5 मिनट पढ़ें",
        externalUrl: "https://www.cmv360.com/tractors/news/autonxt-automation-launching-india-first-self-driving-electric-tractor"
      },
      {
        date: "4/9/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्ट ऑटोमेशन ने सामा (Saama) के नेतृत्व में प्री-सीरीज ए फंडिंग हासिल की",
        summary: "ऑटोनेक्स्ट विभिन्न क्षेत्रों में व्यावसायिक उपयोग के लिए डिज़ाइन किए गए सेल्फ-ड्राइविंग विकल्पों के साथ भारत का पहला इलेक्ट्रिक ट्रैक्टर लॉन्च करने के लिए तैयार है।",
        author: "ऑनलाइन ब्यूरो",
        readTime: "2 मिनट पढ़ें",
        externalUrl: "https://auto.economictimes.indiatimes.com/news/automotive/autonxt-automation-secures-pre-series-a-funding-led-by-saama/109165048"
      },
      {
        date: "4/10/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्ट ऑटोमेशन भारत का पहला सेल्फ-ड्राइविंग इलेक्ट्रिक ट्रैक्टर पेश करेगा, प्री-सीरीज ए फंडिंग सुरक्षित",
        summary: "ऑटोनेक्स्ट ऑटोमेशन ने सामा (Saama) के नेतृत्व में अपने प्री-सीरीज़ ए फंडिंग राउंड को सफलतापूर्वक पूरा कर लिया है, सेल्फ-ड्राइविंग क्षमताओं के साथ भारत का पहला इलेक्ट्रिक ट्रैक्टर पेश करने की तैयारी कर रहा है।",
        author: "सुनैहा मिश्रा",
        readTime: "4 मिनट पढ़ें",
        externalUrl: "https://tractornews.in/news/autonxt-automation-to-introduce-india-s-first-self-driving-electric-tractor-secures-pre-series-a-funding/"
      },
      {
        date: "4/9/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्ट ऑटोमेशन ने सामा (Saama) से प्री-सीरीज ए फंडिंग हासिल की",
        summary: "ऑटोनेक्स्ट ऑटोमेशन वाणिज्यिक अनुप्रयोगों के लिए भारत के पहले सेल्फ-ड्राइविंग इलेक्ट्रिक ट्रैक्टर के विकास में तेजी लाने के लिए महत्वपूर्ण धन सुरक्षित करता है।",
        author: "ट्रैक्टर जंक्शन",
        readTime: "3 मिनट पढ़ें",
        externalUrl: "https://www.tractorjunction.com/tractor-news/autonxt-automation-secures-pre-series-a-funding-from-saama/"
      },
      {
        date: "4/9/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्ट ने इलेक्ट्रिक स्वायत्त ट्रैक्टर विकास के लिए प्री-सीरीज ए फंडिंग हासिल की",
        summary: "ऑटोनेक्स्ट ऑटोमेशन ने वाणिज्यिक और कृषि अनुप्रयोगों के लिए इलेक्ट्रिक स्वायत्त ट्रैक्टरों के विकास को आगे बढ़ाने के लिए प्री-सीरीज़ ए फंडिंग हासिल की है।",
        author: "मेरकॉम इंडिया",
        readTime: "3 मिनट पढ़ें",
        externalUrl: "https://www.mercomindia.com/autonxt-pre-series-a-funding"
      },
      {
        date: "4/10/2024",
        tag: "नवाचार",
        title: "ऑटोनेक्स्ट का गेम-चेंजिंग इलेक्ट्रिक ट्रैक्टर भारत में कृषि और उद्योग को बदलने के लिए तैयार",
        summary: "सेल्फ-ड्राइविंग क्षमताओं के साथ ऑटोनेक्स्ट का क्रांतिकारी इलेक्ट्रिक ट्रैक्टर पूरे भारत में कृषि और औद्योगिक संचालन को बदलने के लिए तैयार है।",
        author: "अहमदाबाद मिरर",
        readTime: "4 मिनट पढ़ें",
        externalUrl: "https://www.ahmedabadmirror.com/autonxts-game-changing-electric-tractor-set-to-transform-farming-and-industry-in-india/81891265.html"
      },
      {
        date: "4/10/2024",
        tag: "कृषि",
        title: "भारतीय कृषि में क्रांति: ऑटोनेक्स्ट के इलेक्ट्रिक ट्रैक्टर किसानों के लिए बुद्धिमत्ता और स्थिरता ला रहे हैं",
        summary: "ऑटोनेक्स्ट के इलेक्ट्रिक ट्रैक्टर देश भर के किसानों के लिए बुद्धिमत्ता, स्थिरता और लाभप्रदता लाकर भारतीय कृषि में क्रांति ला रहे हैं।",
        author: "फ़र्स्ट इंडिया",
        readTime: "5 मिनट पढ़ें",
        externalUrl: "https://firstindia.co.in/news/press-releases/revolutionizing-indian-agriculture-autonxts-electric-tractors-bring-intelligence-sustainability-and-profitability-to-farmers"
      },
      {
        date: "4/9/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्ट ऑटोमेशन ने इलेक्ट्रिक ऑटोनॉमस ट्रैक्टर के लिए प्री-सीरीज ए फंडिंग हासिल की",
        summary: "ऑटोनेक्स्ट ऑटोमेशन टिकाऊ कृषि समाधानों के लिए इलेक्ट्रिक स्वायत्त ट्रैक्टरों के विकास को आगे बढ़ाने के लिए प्री-सीरीज़ ए फंडिंग सुरक्षित करता है।",
        author: "ईवी रिपोर्टर",
        readTime: "3 मिनट पढ़ें",
        externalUrl: "https://evreporter.com/autonxt-automation-secures-pre-series-a-funding-for-electric-autonomous-tractor/"
      },
      {
        date: "5/15/2024",
        tag: "मील का पत्थर",
        title: "ऑटोनेक्स्ट ऑटोमेशन का इलेक्ट्रिक ट्रैक्टर आधिकारिक तौर पर ठाणे आरटीओ में पंजीकृत",
        summary: "ऑटोनेक्स्ट ऑटोमेशन ने एक ऐतिहासिक मील का पत्थर हासिल किया क्योंकि उसके 45HP इलेक्ट्रिक ट्रैक्टर को ठाणे, महाराष्ट्र में अपना पहला आधिकारिक वाणिज्यिक आरटीओ वाहन पंजीकरण प्राप्त हुआ।",
        author: "शुगरमिंट",
        readTime: "3 मिनट पढ़ें",
        externalUrl: "https://sugermint.com/autonxt-automation-electric-tractor/"
      }
    ]
  },

  dealerPage: {
    metaTitle: "सेल पार्टनर और डीलर नेटवर्क | AutoNxt इलेक्ट्रिक ट्रैक्टर्स",
    metaDescription: "पूरे भारत में AutoNxt अधिकृत सेल पार्टनर्स, डीलर प्रोफाइल और उनके कार्यों को देखें और आधिकारिक AutoNxt सेल पार्टनर बनने के लिए आवेदन करें।",
    badge: "सेल पार्टनर कार्यक्रम",
    title: "AutoNxt के साथ बनें",
    titleHighlight: "सेल पार्टनर",
    subtitle: "भारत की अग्रणी इलेक्ट्रिक ट्रैक्टर क्रांति में शामिल हों। हमारे देशव्यापी सेल पार्टनर नेटवर्क, डीलर प्रोफाइल और उपलब्धियों को देखें।",
    mapSection: {
      badge: "देशव्यापी नेटवर्क",
      title: "पूरे भारत में AutoNxt की बाजार उपस्थिति",
      subtitle: "हमारे अधिकृत सेल पार्टनर, अनुभव केंद्र और 3S सेवा केंद्र प्रमुख कृषि और औद्योगिक केंद्रों में कार्यरत हैं।",
      stats: [
        { value: "25+", label: "सक्रिय डीलरशिप आउटलेट" },
        { value: "15+", label: "कवर किए गए राज्य" },
        { value: "100%", label: "3S सेवा सहायता" },
        { value: "500+", label: "चार्जिंग नेटवर्क पॉइंट्स" }
      ]
    },
    profilesSection: {
      badge: "डीलर नेटवर्क",
      title: "हमारे अधिकृत सेल पार्टनर्स और कार्य प्रदर्शन",
      subtitle: "भारतीय खेतों और उद्योगों में इलेक्ट्रिक ट्रैक्टर लाने वाले हमारे विश्वसनीय डीलरशिप प्रोफाइल और कार्यों की खोज करें।",
      searchPlaceholder: "डीलर का नाम, शहर, राज्य या कार्य से खोजें...",
      filterAll: "सभी राज्य",
      contactDealer: "पार्टनर से संपर्क करें",
      viewWork: "उपलब्धियां देखें",
    },
    benefits: {
      title: "AutoNxt के साथ पार्टनर क्यों बनें?",
      subtitle: "विशेष लाभ प्राप्त करें और भारत के अग्रणी इलेक्ट्रिक ट्रैक्टर ब्रांड के साथ बढ़ें।",
      items: [
        { title: "विशेष क्षेत्र अधिकार", description: "कोई ओवरलैपिंग डीलरशिप नहीं, आपके क्षेत्र में अधिकतम बाजार क्षमता सुनिश्चित करने वाले समर्पित क्षेत्रीय अधिकार।" },
        { title: "प्रशिक्षण और प्रमाणन", description: "आपकी टीम को विशेषज्ञ-स्तरीय ज्ञान से लैस करने के लिए व्यापक उत्पाद, बिक्री और सेवा प्रशिक्षण।" },
        { title: "मार्केटिंग सहायता", description: "लीड और ब्रांड दृश्यता बढ़ाने के लिए सह-ब्रांडेड मार्केटिंग सामग्री, डिजिटल अभियान और इवेंट सहायता।" },
        { title: "प्रतिस्पर्धी मार्जिन", description: "आकर्षक डीलर मार्जिन और वॉल्यूम-आधारित प्रोत्साहन कार्यक्रम।" }
      ]
    },
    form: {
      title: "सेल पार्टनर बनने के लिए आवेदन करें",
      subtitle: "नीचे फॉर्म भरें और हमारी टीम 24–48 घंटे के भीतर आपसे संपर्क करेगी।",
      name: "पूरा नाम",
      namePlaceholder: "अपना पूरा नाम दर्ज करें",
      email: "ईमेल पता",
      emailPlaceholder: "you@company.com",
      phone: "फोन नंबर",
      phonePlaceholder: "+91 98765 43210",
      company: "कंपनी / फर्म का नाम",
      companyPlaceholder: "आपका व्यवसाय या फर्म का नाम",
      city: "शहर / जिला",
      cityPlaceholder: "जैसे सतारा, नासिक, लुधियाना",
      state: "राज्य",
      statePlaceholder: "अपना राज्य चुनें",
      experience: "वर्तमान व्यवसाय / डीलरशिप अनुभव",
      experiencePlaceholder: "जैसे ऑटो / कृषि मशीनरी में 5+ वर्ष",
      message: "आप AutoNxt सेल पार्टनर क्यों बनना चाहते हैं?",
      messagePlaceholder: "अपने शोरूम/वर्कशॉप और विजन के बारे में बताएं...",
      submit: "सेल पार्टनर आवेदन जमा करें",
      submitting: "जमा हो रहा है...",
      successTitle: "आवेदन जमा हो गया!",
      successMessage: "AutoNxt पार्टनर बनने में आपकी रुचि के लिए धन्यवाद। हमारी टीम जल्द ही आपसे संपर्क करेगी।",
      errorMessage: "कुछ गड़बड़ हो गई। कृपया पुनः प्रयास करें।",
      submitAnother: "एक और आवेदन जमा करें"
    },
    states: [
      "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
      "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
      "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
      "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
      "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
      "Uttar Pradesh", "Uttarakhand", "West Bengal",
      "Delhi", "Jammu & Kashmir", "Ladakh", "Puducherry", "Chandigarh"
    ],
    directory: {
      tag: "अधिकृत नेटवर्क",
      title: "अधिकृत डीलर और स्थान",
      subtitle: "भारत भर में ऑटोनेक्स्ट के सत्यापित अधिकृत डीलरशिप केंद्रों, बिक्री भागीदारों और सेवा केंद्रों के नेटवर्क का अन्वेषण करें।",
      searchPlaceholder: "डीलर का नाम, शहर, ईमेल, मोबाइल या पता खोजें...",
      allStates: "सभी राज्य",
      dacNumber: "डीएसी संख्या",
      dealerName: "डीलर का नाम",
      email: "डीलर ईमेल",
      mobile: "डीलर मोबाइल",
      gstNo: "डीलर जीएसटी नंबर",
      panNo: "डीलर पैन",
      address: "पता",
      noResults: "आपकी खोज से मेल खाने वाला कोई अधिकृत डीलर नहीं मिला।",
      resetSearch: "फ़िल्टर रीसेट करें",
      dealers: [
        {
          id: "4",
          dealerName: "कंपेज ऑटोमेशन सिस्टम",
          address: "प्लॉट नं. 20-21, सेक्टर 12, न्यू डीएलएफ इंडस्ट्रियल एरिया, हरियाणा, फरीदाबाद, 121003",
          state: "हरियाणा"
        },
        {
          id: "5",
          dealerName: "किसान कल्याण एंटरप्राइजेज",
          address: "शॉप 02, मोर हाउस ग्राउंड फ्लोर, कोर्ट एरिया, रेमंड के सामने, बाढ़, पटना, बिहार, 803213",
          state: "बिहार"
        },
        {
          id: "6",
          dealerName: "एसएस कॉर्पोरेशन",
          address: "खतौनी नं 5152, खेवट नं 3262, एन, नमस्ते चौक, करनाल, हरियाणा, 132001",
          state: "हरियाणा"
        },
        {
          id: "7",
          dealerName: "साई सीमा ऑटोमोटिव",
          address: "गट नं 579/580 साई सीमा ऑटोमोटिव, कोकणगांव निफाड़, पिंपलगांव बसवंत, महाराष्ट्र, नासिक, 422209",
          state: "महाराष्ट्र"
        }
      ]
    }
  },

  // Team Page
  teamPage: {
    metaTitle: "हमारी टीम और नेतृत्व | AutoNxt इलेक्ट्रिक ट्रैक्टर्स",
    metaDescription: "AutoNxt Automation में भारत के पहले इलेक्ट्रिक और स्वायत्त ट्रैक्टर तकनीक को संचालित करने वाले इंजीनियरों, नवप्रवर्तकों और नेताओं से मिलें।",
    badge: "हमारे नवप्रवर्तक",
    title: "मिलिए AutoNxt के",
    titleHighlight: "निर्माताओं से",
    subtitle: "दूरदर्शी नेताओं, मैकेनिकल इंजीनियरों, पावरट्रेन विशेषज्ञों, रोबोटिक्स पेशेवरों और कृषि प्रौद्योगिकीविदों की एक बहु-विषयक टीम जो भारतीय गतिशीलता का विद्युतीकरण कर रही है।",
    stats: [
      { value: "150+", label: "उत्साही नवप्रवर्तक" },
      { value: "10+", label: "इंजीनियरिंग विधाएं" },
      { value: "50+", label: "पेटेंट और प्रमाणन" },
      { value: "100%", label: "स्वदेशी नवाचार" }
    ],
    categories: {
      all: "सभी सदस्य",
      leadership: "नेतृत्व",
      finance: "वित्त एवं रणनीति",
      sales: "सेल्स टीम",
      powertrain: "पावरट्रेन और बैटरी",
      robotics: "रोबोटिक्स और सॉफ्टवेयर",
      manufacturing: "संयंत्र और विनिर्माण",
      advisors: "सलाहकार बोर्ड"
    },
    leadershipTitle: "कार्यकारी नेतृत्व",
    leadershipSubtitle: "टिकाऊ मशीनीकरण और स्वायत्त भविष्य के लिए एक साहसिक दृष्टिकोण के साथ AutoNxt का मार्गदर्शन करना।",
    teamTitle: "कोर इंजीनियरिंग और संचालन",
    teamSubtitle: "उच्च-टॉर्क वाले इलेक्ट्रिक ट्रैक्टरों को डिजाइन, निर्माण और परिपूर्ण करने वाली विश्व स्तरीय प्रतिभा।",
    advisorsTitle: "रणनीतिक सलाहकार बोर्ड",
    advisorsSubtitle: "उद्योग के दिग्गज और डोमेन विशेषज्ञ जो AutoNxt को वैश्विक उत्कृष्टता की ओर ले जा रहे हैं।",
    connectLinkedIn: "लिंक्डइन पर जुड़ें",
    connect: "जुड़ें",
    ctaBadge: "AutoNxt में करियर",
    ctaTitle: "क्या आप इलेक्ट्रिक कृषि का भविष्य बनाना चाहते हैं?",
    ctaDesc: "नवप्रवर्तकों, विचारकों और निर्माताओं की तेजी से बढ़ती टीम में शामिल हों। इंजीनियरिंग, संचालन और सॉफ्टवेयर में अवसरों का अन्वेषण करें।",
    ctaButton: "खुले पद देखें",
    teamMembers: [
      {
        name: "कौस्तुभ धोंडे",
        role: "मुख्य कार्यकारी अधिकारी (CEO)",
        category: "leadership",
        bio: "अभिनव इलेक्ट्रिक वाहन समाधानों के साथ कृषि में क्रांति लाने के AutoNxt के मिशन का नेतृत्व करने वाले दूरदर्शी लीडर।",
        featured: true
      },
      {
        name: "पंकज गोयल",
        role: "सह-संस्थापक और सीओओ (COO)",
        category: "leadership",
        bio: "सुलभ निष्पादन और विकास सुनिश्चित करने वाले रणनीतिकार, दैनिक संचालन और साझेदारियों की देखरेख करते हैं।",
        featured: true
      },
      {
        name: "गौरव बोरकर",
        role: "चीफ फाइनेंशियल ऑफिसर (CFO)",
        category: "finance",
        bio: "वित्तीय रणनीति, फंड जुटाने और कॉर्पोरेट गवर्नेंस का नेतृत्व करने वाले अनुभवी वित्त विशेषज्ञ।",
        featured: true
      },
      {
        name: "अमित कुमार शिवहरे",
        role: "हेड – अकाउंट्स एंड फाइनेंस (Head – Accounts & Finance)",
        category: "finance",
        bio: "ईवी विनिर्माण, प्रौद्योगिकी और बुनियादी ढांचे में वित्तीय रणनीति, शासन और व्यावसायिक प्रदर्शन का नेतृत्व करने वाले वरिष्ठ वित्त लीडर।"
      },
      {
        name: "हरि किशन",
        role: "प्लांट हेड",
        category: "manufacturing",
        bio: "संयंत्र संचालन की देखरेख करते हैं, प्रत्येक निर्मित ट्रैक्टर में गुणवत्ता और दक्षता सुनिश्चित करते हैं।"
      },
      {
        name: "सुदीप्तो देब",
        role: "लीड पावर ट्रेन इंजीनियर",
        category: "powertrain",
        bio: "पावर इलेक्ट्रॉनिक्स विशेषज्ञ, हमारे ट्रैक्टरों को शक्ति देने वाले इलेक्ट्रिकल सिस्टम को डिजाइन और अनुकूलित करते हैं।"
      },
      {
        name: "वामसी अट्लुरी",
        role: "लीड मैकेनिकल डिजाइन इंजीनियर",
        category: "powertrain",
        bio: "विविध कृषि आवश्यकताओं के लिए मजबूत और कुशल ट्रैक्टर संरचनाएं तैयार करने वाले मैकेनिकल डिजाइन इनोवेटर।"
      },
      {
        name: "डॉ. धर्मतेजा अदापा",
        role: "लीड रोबोटिक्स इंजीनियर",
        category: "robotics",
        bio: "सहज और विश्वसनीय ट्रैक्टर प्रदर्शन के लिए स्मार्ट तकनीकों को एकीकृत करने पर केंद्रित स्वचालन विशेषज्ञ।"
      },
      {
        name: "तेजेश मादिरेड्डी",
        role: "लीड एम्बेडेड इंजीनियर",
        category: "robotics",
        bio: "विश्वसनीय और कुशल हार्डवेयर-सॉफ्टवेयर एकीकरण सुनिश्चित करते हुए एम्बेडेड सिस्टम विकास का नेतृत्व करते हैं।"
      },
      {
        name: "अश्वंथ मुलुपुरी",
        role: "रोबोटिक्स और ऑटोमेशन इंजीनियर",
        category: "robotics",
        bio: "स्वायत्त ट्रैक्टर संचालन के लिए उन्नत नियंत्रण प्रणाली विकसित करने वाले स्वचालन विशेषज्ञ।"
      },
      {
        name: "अजिंक्य डेलवी",
        role: "पावर ट्रेन इंजीनियर",
        category: "powertrain",
        bio: "पावर ट्रेन सिस्टम पर काम करते हुए प्रदर्शन और ऊर्जा दक्षता का अनुकूलन करते हैं।"
      },
      {
        name: "खुशप्रीत सिंह",
        role: "परीक्षण और सत्यापन इंजीनियर",
        category: "manufacturing",
        bio: "कड़े परीक्षण और सत्यापन के लिए जिम्मेदार, उत्पादों की विश्वसनीयता और सुरक्षा की गारंटी देते हैं।"
      },
      {
        name: "स्वप्नेश जहागीरदार",
        role: "बिजनेस डेवलपमेंट मैनेजर",
        category: "sales",
        bio: "कंपनी के विस्तार में तेजी लाने के लिए नए अवसरों की पहचान और संबंधों को बढ़ावा देने पर केंद्रित।"
      }
    ],
    advisorsList: [
      {
        name: "आईवी-राव",
        role: "वरिष्ठ सलाहकार",
        bio: "मारुति सुजुकी के पूर्व कार्यकारी सलाहकार और इंजीनियरिंग प्रमुख। ऑटोमोटिव आर्किटेक्चर और सिस्टम इंजीनियरिंग में AutoNxt का मार्गदर्शन।"
      },
      {
        name: "आशीष मेहता",
        role: "वित्तीय सलाहकार",
        bio: "पूंजी आवंटन, वेंचर स्केल और टिकाऊ वाणिज्यिक विस्तार पर सलाह देने वाले अनुभवी वित्तीय रणनीतिकार।"
      },
      {
        name: "स्वादीप पिल्लारीसेट्टी",
        role: "रणनीति सलाहकार",
        bio: "उत्पाद-बाजार अनुकूलता, उद्यम बिक्री पाइपलाइनों और उच्च-प्रभाव वाली साझेदारियों को गति देने में विशेषज्ञ।"
      }
    ]
  }
};
